import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

const messages = {
    tr: {
        volumeUp: "Sesi Aç",
        minimize: "Küçült",
        maximize: "Büyüt",
        wp: {
            whatsapp: "Whatsapp",
            chatStartingWait: "Konuşma başlatılıyor , Lütfen Bekleyiniz",
            chatStarted: "Konuşma başlatıldı",
            chatNotStarted: "Konuşma başlatılamadı",
            agreement: "Sözleşme",
            purchase: "Satın Alma",
            activating: "Whatsapp Hizmeti Etkinleştirme",
            authenticating: "QR Kodu Doğrulama",
            ready: "Tamamla",
            activationTitle: "Supsis Üzerinde Whatsapp Entegrasyonu Etkinleştirme:",
            wpIntegrationInstruction1: "Whatsapp'ı Telefonunuzda Açın",
            wpIntegrationInstruction2: "Menü'yü yada Ayarlar'ı seçin ve Bağlı Cihazlar'a tıklayın. ",
            wpIntegrationInstruction3: "Kodu taramak için telefonunuzu bu ekrana doğrultun",
            qrGeneratingWait: "QR Kodu Oluşturuluyor lütfen bekleyin...",
            pleaseContinueToWaitUntilCompleted:
                    "QR Kodu doğrulandıktan sonra otomatik olarak tamamlandı alanına geçecektir. Lütfen bekleyiniz...",
            authenticatingWait: "Oturum açılıyor, lütfen bekleyin...",

            enableFeature: "Whatsapp Özelliğini Etkinleştir",
            unsubscribeWpInetgration: "Whatsapp Entegrasyonu aboneliğini sonlandır",
            wpBack: "Geri",
            terminatelWpInetgration:
                "Abonelikten çık butonuna tıkladığınızda whatsapp entegrasyonunuz sonlandırılacaktır.",
            cancelWpInetgration: "Whatsapp entegrasyonunu iptal etmek istiyor musunuz?",
            startChatWp: "Sohbet Başlat",
            readAndAgree: "Okudu onaylıyorum",
            subscribe: "Abone Ol",
            subscribed: "Abone olundu",
            toEnableWpDescription: "Whatsapp Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
            waitForWpActivationDescription:
                "Whatsapp hesap hizmetiniz aktif hale geliyor. Lütfen bekleyin. Yaklaşık 30 saniye sürer.",
            greatWpActivatedDescription: "Whatsapp hesap hizmetiniz etkinleştirildi.",
            unsubscribe: "Abonelikten Çık",
            planDetails: "Entegrasyon Detayları",
            sendReceiveMessage: "Mesaj Gönderme & Alma ",
            sendReceiveImage: "Resim Gönderme & Alma ",
            sendReceiveAudio: "Ses Kaydı Gönderme & Alma ",
            sendReceiveGif: "GIF Gönderme & Alma",
            startChat: "Supsis'te Chat Başlatma",
            supsisFunctionality: "Kullanışlı Supsis Sohbet Özelliği",
            onePhoneMultiAgent: "Tek Telefon ile Birden Fazla Temsilci",
            basicIntegration: "Uğraştırmayan Basit Entegrasyon",
            purchaseHeader: "Supsis-Whatsapp Entegrasyonu Satın Alma",
            wpServices: "Whatsapp Hizmeti",
            wpServicesIntegrationCompleted: "Whatsapp entegrasyonunuz tamamlandı. Artık kullanabilirsiniz.",
            purchasePaymentDescription:
                "Whatsapp Özelliği aydan aya faturalandırılır. Aboneliği kabul ettikten sonra whatsapp hizmetiniz aktif hale gelecektir.",
            wpIntegrationFeatures:"Whatsapp Entegrasyonu Özellikler",
        },
        ticket: {
            ticketTagFilter: "Ticket Konusu Filtre Etiketi",
            ticketEmails: "Yönlendirelecek E-Posta Listesi",
            save: "Kaydet",
            delete: "Sil",
            transactions: "İşlemler",
            noEmailTicketNotifications: "Ticket Eposta  Yönlendirme Kaydı Bulunamadı",
            emailIsNotValid: "Eposta Adresi Geçersiz",
            emailNotificationDeleted: "Ticket Yönlendirme Kaydı Silindi",
            emailNotificationDeleteError: "Ticket Yönlendirme Kaydı Silinemedi!!",
            tagFilterRequired:
                "Ticket Konusu Filtre Etiketi Gereklidir. Tüm ticket'lar için * (wildcard) etiketini kullanabilirsiniz!",
            emailsRequired: "Ticket Yönlendirmesi için en az 1 Eposta adresi girilmelidir",
            emailNotificationCreated: "Ticket Yönlendirme Kaydı Oluşturuldu",
            emailNotificationCreateError: "Ticket Yönlendirme Kaydı Oluşturulamadı!!",
            ticketForwarding: "Ticket Eposta Yönlendirme",
            ticketTagFilterDesc:
                "Ticket filtrelemek için chatbot tasarımda kullandığınız ticket konularını kullanır. Farklı bir etiket yazıp enter'a basıp ekleyebilirsinz. '*' etiketi seçerseniz tüm ticketları seçer",
            ticketEmailsDesc:
                "Ticket'ların yönlendireleceği eposta listesi. Sistemdeki temsilcilerin adresleri seçerek ekleyebilirsiniz. Sistem dışı  eposta/lar da ekleyebilirsiniz.",
            ticketList: "Ticket Yönlendirme Kuralları",
            ticketTagFilterPlaceHolder: "Ticket filtresi, hepsi için * seçiniz",
            ticketEmailsPlaceHolder: "Yönlendirme eposta listesi",
        },
        theme: {
            headerColor1: "Başlık Kısmı 1. Renk",
            headerColor1A: "Başlık Kısmı 1. Saydamlık",
            headerColor2: "Başlık Kısmı 2. Renk",
            headerColor2A: "Başlık Kısmı 2. Saydamlık",
            backgroundColor: "Arkaplan 1. Rengi",
            backgroundColorA: "Arkaplan 1. Saydamlık",
            backgroundColor2: "Arkaplan 2. Rengi ",
            backgroundColor2A: "Arkaplan 2. Saydamlık ",

            opacity: "Saydamlık",

            textColor: "Metin Rengi",
            errorTheme: "Hata Rengi",
            bubbleBackground: "Sohbet Balonu Arkaplan Rengi",
            bubbleBackgroundA: "Sohbet Balonu Arkaplan Saydamlık",
            bubbleText: "Sohbet Balonu Yazı Rengi",
            selectCustom: "Özel Tema Seç",
        },
        billing: {
            invoice: "Fatura",
            mustBeUpgradePlanForChatBot: "Chatbot özelliğini aktif edebilmeniz için Pro Plan'a geçmelisiniz!",
            cardInfo: "Kart Bilgisi",
            billingDetails: "Fatura Detayları",
            addCardIyzico:
                "Kayıtlı bir kartınız bulunmamaktadır. Aylık kullanım ücretlerinizi ödeyebilmeniz için kart eklemeniz gerekmektedir.Ödeme sistemi iyzico tarafından sağlanmaktadır.",
            billingPlanSettings: "Fatura & Ödeme Yöntemi",
            paymentMethod: "Ödeme Yöntemi",
            billingDate: "Fatura Tarihi",
            isPaid: "Ödendi mi?",
            paid: "Ödendi",
            markPaid: "Ödendi Olarak İşaretle",
            paymentDate: "Ödeme Tarihi",
            pay: "Faturayı Öde",
            newInvoice: "Fatura Oluştur",
            updateBilling: "Fatura Adresini Değiştir",
            updateCard: "Kredi Kartını Değiştir",
            paymentBilling: "Ödeme Metodu & Fatura Adresi",
            price: "Fatura Tutarı",
            billingAddress: "Açık Adres",
            billingCity: "Şehir",
            billingCountry: "Ülke",
            contactName: "Faturalandırma Kişi Adı",
            expireMonth: "Son Kullanma T. Ay",
            expireYear: "Son Kullanma T. Yıl",
            cardNumber: "Kart Numarası",
            cardHolderName: "Kart Üzerindeki Ad Soyad",
            cardAlias: "Kart takma isim",
            identityNumber: "Kimlik/Vergi  Numarası",
            name: "Ad",
            surname: "Soyad",
            email: "Eposta",
            addCard: "Kart Ekle",
            update: "Güncelle",
            cancel: "Vazgeç",
            save: "Kaydet",
            saving: "Kaydediliyor",
            noInvoiceFound: "Fatura kaydı bulunamadı",
            year: "Yıl",
            updating: "Güncelleniyor",
            newInvoiceForm: "Yeni Fatura Oluşturma Formu",
            error: "Hata",
            transactions: "İşlemler",
            paymentMethodAdded: "Ödeme yöntemi başarıyla eklendi",
            paymentMethodAddError: "Ödeme yöntemi eklenemedi, Hata oluştu",
            creditCardChanged: "Kredi kartınız değiştirildi",
            errorOccurred: "Bir hata oluştu, tekrar deneyin.",
            billingDetailUpdated: "Fatura bilgileriniz güncellendi",
            invoiceCreated: "Fatura kaydı başarıyla oluşturuldu",
            paymentSuccess: "Faturanız başarıyla ödendi, teşekkür ederiz",
            paymentFail: "Faturanız ödenirken  hata oluştu daha sonra tekrar deneyiniz.",
            startWith: "{binNumber} ile başlayan {cardFamily} kart",
            billingAddressChanged: "Fatura Adresi bilgileri güncellendi ",
            hidePlan: "Planı Gizle",
            informationShopping:
                "Ödeme bilgileriniz, fatura bilgileriniz, kredi kartı bilgileriniz Shopify tarafından kontrol edilmektedir.",
            trialTimeInformation:
                "Deneme Sürümü bitmesine {dayCount} gün kaldı. Bu süre bitimine kadar ödeme yöntemi girmemeniz durumunda sistem tarafından otomatik olarak FREE Plan'a geçilir.",
            trialTimeInformationShort: "Son {dayCount} Gün",
            currentPlanLabel: "Mevcut Plan: {planName} Plan ({agentCount} Temsilci)",
            changeCancelPlan: "Planı Değiştir/İptal et",
            oneAgent: "Temsilci",
            agent: "Temsilci",
            yourCurrentPlan: "Mevcut Plan",
            month: "Ay",
            billedMonthToMonth: "(Aylık Faturalandırma)",
            selectAgentCount: "Temsilci Sayısı Seçin",
            selectFreePlan: "Free Plan Seçin",
            planDetails: "Plan Detayları",
            multiAgent: "(Çok Temsilci)",
            selectProPlan: "Pro Plan Seçin",
            foreverFree: "Süresiz Free",
            websiteIntegration: "Web Sitesi Entegrasyonu",
            websiteIntegrationUnlimited: "Web Sitesi Entegrasyonu",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Görüntülü Arama",
            multiAgentUpTo: "Çok Temsilcili ({agentCount} Temsilciye Kadar)",
            audioCallUnlimited: "Sesli Arama",
            screenSharingUnlimited: "Ekran Paylaşımı",
            fileTransferUnlimited: "Dosya Paylaşımı",
            autoChatAssignerUnlimited: "Otomatik Sohbet Ataması",
            multiLanguageTranslationUnlimited: "Otomatik Dil Çeviricisi",
            detailedReporting: "Raporlama",
            days30TrialsAvailable: "30-Günlük Ücretsiz Deneme",
            limitedArchiveLookupLastMo: "Sınırlı Arşiv Araması (Son {monthCount}-ay)",
            fullCustomizationUnlimited: "Özelleştirme",
            planUpdated: "Planınız başarıyla güncellendi.",
            planUpdating: "Planınız güncelleniyor...",
            planUpdatingDescription: "Güncelleme süresince lütfen bekleyin!",
            done: "Tamamlandı",
            freePlanUpdated: "Planınız Free Plan olarak güncellendi. (Maksimum Temsilci Sayısı: 1)",
            proPlanUpdated: "Planınız Pro Plan olarak güncellendi. (Maksimum Temsilci Sayısı: {agentCount}) ",
            canNotDwnGrade:
                "Planınız PRO {agentCountFirst} Temsilci sayısından {valNewPlnToUppr} {agentCountSecond} sayısına  düşürülemez!. Temsilci kredileriniz kullanımda. ",
            deleteWarning: " {valDif} Temsilci silmeniz gerekmektedir.",
            warnMessage: "Seçilen plan, mevcut plandan farklı olmalıdır",
            add: "Ekle",
            cancelYourPlan: "Planını İptal Et",
            upgradeYourPlan: "Planını Yükselt",
            downgradeYourPlan: "Planını Düşür",
            agree: "KABUL ET",
            disagree: "VAZGEÇ",

            invoices: "Faturalar",
            priceIntervals: "Tutar Aralığı",
            selectSiteAlias: "Site Adı Girin veya Seçin",
            selectPriceInterval: "Tutar Aralığı Girin veya Seçin",
            isRefunded: "Geri Ödeme Yapıldı mı?",
            invoiceId: "Fatura No",
            siteId: "Site No",
            createdDate: "Olurşturulma Tarihi",
            failCount: "Yapılmayan Ödeme sayısı",
            failDate: "Yapılmayan Ödemenin tarihi",
            Dashboard: "Gösterge Paneli",
            Agents: "Temsilciler",
            Integration: "Entegrasyon",
            Settings: "Ayarlar",
            Contacts: "Bağlantılar",
            Domain: "Domain",
            lastActivity: "Son Aktivite",
            basePrice: "Taban Fiyat",
            packagePrice: "Paket Fiyatı",
            whatsappPrice: "Whatsapp Fiyatı",
            realtimeVisitorCount: "Anlık Ziyaretçi",
            suspend: "Askıya Al",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Deneme Günü",
            mobile: "Mobil",
            webSite: "Web Sitesi",
            websiteOrigins: "Web Sitesi Kaynağı",
            ownerName: "Sahibinin Adı",
            ownerEmailAddress: "Sahibinin Email'i",
            discount: "İndirim",
            daysLeft: "Kalan Gün",
            newTrialPopUp: "Yeni Deneme Süresi Kaç Gün Olsun",
            newWpPricePopUp: "Yeni Whatsapp Ücreti Ne Kadar Olsun ?",
            newBasePricePopUp: "Yeni Supsis Taban Fiyatı Ne Kadar Olsun ?",
            siteInfoUpdated: "Site Bilgisi Güncellendi",
            siteInfoNotUpdated: "Site Bilgisi Güncellenmedi",
            siteInfoNotUpdatedErr: "Hata Oluştu! Site Bilgisi Güncellenmedi.",
        },
        chatbot: {
            link: "Bot, verdiğiniz bağlantıyı mesaj olarak gönderir",
            linkTitle: "Bağlantınızın görünecek başlığıdır",
            linkAddress: "Bağlantınızın hedef adresidir",
            goto: "Bot, belirttiğiniz adıma geri döner",
            text: "Bot, verdiğiniz metni mesaj olarak gönderir",
            randomText: "Bot, verdiğiniz metin listesinden rastgele bir tanesi seçerek mesaj olarak gönderir.",
            image: "Bot , yüklediğiniz görüntüyü görsel mesaj olarak gönderir",
            ticket: "Bot , bu aşamaya gelen ziyaritçiler sorunlarının daha sonra çözülmesi için sisteme ticket açar.",
            ticketTopic: "Ticket konusudur. Bot ticket açacağı zaman bu konuyu etiketler",
            ticketMessage: "Bot ticket açtıktan sonra kulllanıcya göndereceği mesajı buraya giriniz",
            button: "Botun karşı tarafa bir seçenek sunmasını sağlar",
            question: "Kullanıcıdan bilgi almak için botun soru sormasını sağlar",
            prev: "Bir önceki üst menüye dönmesini sağlar",
            closeChat: "Buradaki mesajlar bot tarafından gönderildikten sonra konuşma sonlandırılır",
            transferLiveChatOption:
                "Bu seçenek menü seçiminde gözükür, dileyen ziyaretçi tıklayarak konuşmayı canlı bir temsilciye aktarabilir",
            delay: "Mesajları belli bir süre bekletip temsilci yazıyor bildirimi gittikten sonra mesaj gönderilir",
            upload: "Resim yüklemek için tıklayınız",
            imageView: "Resmi büyük boyutta görüntülemek için tıklayınız",
            finishStep: "Bu adımdam sonra konuşma otomatik kapanacaktır",
            warnStep:
                "Bu adımdam sonra başka bir adım eklemediğiniz veya konuşmayı kapat özelliğini açmadığınız için bot canlı bir temsilciye yönlendirecektir",
            deleteChatBotStepQuestion: "Bu adımı silmek istediğinize emin misiniz ?",
            chatbotStepWasDeleted: "Başarıyla silinmiştir",
            deleteMessageQuestion: "Bu mesajı silmek istediğinize emin misiniz",
            startToDesign: "Tasarıma Başlayın",
            keywords: "ANAHTAR SÖZCÜKLER",
            typeKeyword: "Anahtar Sözcük Yazın",
            snDelay: "{delay} sn gecikme",
            welcome: "Hoşgeldiniz",
            untitled: "Başlıksız",
            menuMessage: "Menü Giriş Mesajı",
            untitledMenu: "Başlıksız Menü",
            selection: "Seçenekler",
            addNewButton: "Yeni Buton Ekle",
            questionMessage: "Soru Mesajınızı Giriniz..",
            userName: "Kullanıcı Adı",
            untitledForm: "Başlıksız Form",
            descriptionUserName: "Lütfen, kullanıcı adınızı giriniz",
            makeChoice: "Seçiminizi Yapınız",
            subject: "Konu",
            menu: "Menü",
            contentTitle: "İçerik Başlığı",
            subjectTitle: "Konu Başlığı",
            buttonTitle: "Buton Başlığı",
            ticketSuccesfull: "Ticket Başarılı Mesajı",
            randomTextPlaceHolder: "Rastgele metin",
            yes: "Evet",
            no: "Hayır",
            questionLabel: "Soru Etiketini Giriniz..",
            onlyImage: "Sadece Resim Yükleyebilirsiniz!",
            imageSize: "Resminizin Boyutu En Fazla {size} Olmalıdır!",
            types: {
                text: "METİN",
                image: "RESİM",
                ticket: "MESAJ",
                random: "RASTGELE",
                goto: "GIT",
                link: "BAĞLANTI",
            },
        },
        tour: {
            stats: "İSTATİSTİK PANELİ",
            chats: "CHAT PANELİ",
            settings: "AYARLAR",
            status: "DURUM",
            prevStep: "Önceki Adım",
            nextStep: "Sonraki Adım",
            finish: "Bitir",
            skip: "Atla",
            skip2: "Sistemi biliyorum bir daha gösterme",
            startTour: "Tura Başla",
            firstTimeIntro:
                "Sisteme ilk defa girdiğini keşfettim izin verirsen ufak bir tanıtıcı tur başlatmak istiyorum",
            hi: "Merhaba",
            welcomeTo: "Supsis Canlı Destek'e Hoşgeldin",
            statsPanel: "Sistemle anlık olarak bekleyen, toplam, aktif chat sayılarını gösteren durum çubuğudur.",
            sidebarMenu: "Menü",
            sidebarMenuContent: "Sayfalar arası geçişleri buradan yapabilirsiniz.",
            representativePrivateMessage: "Temsilciler Arası Konuşma Paneli",
            representativePrivateMessageContent: "Temsilciler arası özel konuşmaları buradan görebilirsiniz.",
            helpMenu: "Yardım Menüsü",
            helpMenuContent: "Sistem hakkında yardım bilgilerine buradan ulaşabilirsiniz.",
            settingsMenu: "Ayarlar Menüsü",
            settingsMenuContent: "Dil, gece modu ve ekran büyütme adımlarını buradan yapabilirsiniz.",
            profileMenu: "Profil Menüsü",
            profileMenuContent: "Müsaitlik durumunuzu değiştireblir ve temsilci ayarlarınızı buradan yapabilirsiniz.",
            visitorsTab: "Ziyaretçiler",
            visitorsTabContent: "Ziyaretçileri buradan görebilirsiniz.",
            visitorTabHistory: "Ziyaretçi Geçmişi",
            visitorTabHistoryContent: "Ziyaretçi geçmişini buradan görebilirsiniz.",
            representativ_eTab: "Temsilciler",
            representativeTabContent: "Temsilcileri buradan görebilirsiniz.",
            liveSupport: "Canlı Destek",
            liveSupportContent: "Canlı Destek alan müşteri sayısını buradan görebilirsiniz. ",
            siteVisitors: "Site Ziyaretçileri",
            siteVisitorsContent: "Site ziyaretçi sayısını buradan görebilirsiniz. ",
            tableSettings: "Tablo Ayarları",
            tableSettingsContent: "Tabloda kolon gösterme veya gizlemeyi buradan yapabilirsiniz.",
            watchModeButton: "İzleyici Butonu",
            watchModeContent: "İzleyici mode olarak buradan katılabilirsiniz ve sadece yazılanları görüntülersiniz.",
            popoverInfo: "Ziyaretçi Detay",
            popoverInfoContent: "Ziyaretçi hakkında  bilgi verir.",
            popoverButton: "Gelişmiş Konuşma Ayarları",
            popoverButtonContent:
                "Konuşmayı açar, temsilciye direk mesaj atabilir veya ziyaretçiyi engelleyebilirsiniz.",
            openChat: "Konuşma Katıl Butonu",
            openChatContent: "Konuşmayı buradan açabilirsiniz",
            pagination: "Sayfalama Menüsü.",
            paginationContent: "Sayfa sayısını buradan arttırabilirsiniz.",

            chatwindow: {
                chatWindowSettingsButtons: "KONUŞMA PENCERESİ AYARLAR BUTONU",
                chatWindowActionButtons: "KONUŞMA PENCERESİ GENEL İŞLEM BUTTONLARI",
                chatPanelActions: "KONUŞMA PANELİ İŞLEMLERİ",
                otherPanels: "DİĞER PANELLER",
                settingsButton: "Konuşma engelleme, yönlendirme, gizli mesaj atma ve temsilci atama yapabilirsiniz.",
                chatColorButton: "Konuşma balonlarındaki hangi renk ne anlama geldiğini buradan öğrenebilirsiniz",
                keyboardShortcutButton:
                    "Yazışma esnasında kolaylık sağlayan fonksiyonların veya diğer kullandığın özelliklerin kısayollarını buradan bulabilirsin",
                hideButton: "Açık konuşmayı aşağıya indirir arka planda açık kalmaya devam eder",
                closeButton: "Açık konuşması sonlandırır ve konuşmadan çıkarsınız",
                ellipsisButton:
                    "Daha fazla işlemler burada yer almaktadır. Özel mesaj gönderme , ziyaratci banlama , temsilci atama gibi işlemler buradan yapılır",
                userInfoWidget: "Ziyaretçi hakkında detaylı bilgiler burada yer alacaktır",
                preparedContentWidget:
                    "Burada hazır içerik şablonları bulunmaktadır. İster tıklayarak ister kısayolunu konuşma ekranında yazı yazma alanında kısayol serisi tuşlayarak hazır içerikleri hızlıca ekleyebilirsin",
                chatHistoryWidget:
                    "Bu ziyaretcinin geçmiş konuşmaları varsa burada listelenecektir. Eski konuşma detaylarını buradan inceleyebilirsin",
                chatBarButton:
                    "Aktif konuşmayı buradan engelleyebilir, temsilciye gizli mesaj atabilir ve görüşmeden ayrılabilirsiniz.",
            },
        },
        message: {
            chatLanguage: "Konuşma Dili",
            translating: "Çevriliyor",
            liveSupportStartingWait: "Canlı Destek Başlatılıyor , Lütfen Bekleyiniz",
            buyWhatsapp: "WhatsApp satın alın",
            integrations: "Entegrasyonlar",
            refundInvoiceSure: "Faturayı iade etmek istediğinize emin misiniz?",
            invoiceMarkedAsPaidSuccess: "Fatura ödendi olarak işaretlenmiştir.",
            invoiceMarkedAsPaidError: "Hata , Fatura ödendi olarak işaretlenemedi.",
            deleteConfirm: "Bu {object} gerçekten silmek istiyor musunuz?",
            markPaidConfirm: "Bu faturayı ödendi olarak işaretlemek istediğine emin misin?",
            startChatDesc: "Konuşma Başlat",
            addLink: "Bağlantı",
            selectStep: "Bir adım seçiniz:",
            addGOTO: "Git",
            sendFastLink: "Şifresiz Giriş Linki Gönder",
            or: "Veya",
            allTags: "Tüm Etiketler",
            showDetail: "Detay Göster",
            hideDetail: "Detay Gizle",
            weLlSendPhone: "Telefonunuza Gönderelim",
            weLlSendEmail: "E-Posta Gönderelim",
            linkSentToPhone: "Link sms olarak gönderildi",
            offerlinkSendToPhone: "SMS ile size uygulamamızın indirme linkini gönderelim.",
            offerlinkSendToMail: "Mail ile size uygulamamızın indirme linkini gönderelim.",
            theEmail: "Kayıtlı E-postam",
            differentEmail: "Farklı E-posta",
            linkSentToMailBox: "Link mail adresinize gönderildi",
            errorOccurred: "Hata oluştu !",
            clickStoreIcon: "Telefonunuza uygun olan icona tıklayarak mobil uygulamaya ulaşabilirsiniz",
            meetWithSupsis: "SUPSIS mobil uygulamamız ile tanışmak ister misiniz?",
            downloadMobileApps: "Mobil Uygulamayı İndirin",
            getApps: "Uygulamaları Edinin",
            info: "Bilgi",
            conversationHistory: "Konuşma Geçmişi",
            planInfoHeader: "Plan Bilgisi",
            planInformation: "Planınız {selectedPlan} Plan ({detailMaxAgentCount} Temsilci)",
            creditAvailable: "Planınızda mevcut olan Temsilci krediniz: ",
            upDownGradePlan: "Planınızı yükseltmek/düşürmek istiyorsanız, lütfen",
            click: "Tıklayın",
            all: "Tümü",
            allDepartments: "Tüm Departmanlar",
            preferredLanguage: "Tercih Edilen Dil",
            kmkAutoDepartmentBind: "KMK Otomatik Departmant Bulma",
            kmkAutoDepartmentBindDesc: "KMK Müşteri sayfalarında otomatik mağaza adını bulur ve login formuna set eder",
            visitorEmailUpdated: "Ziyaretci eposta adresi güncellendi",
            visitorEmailIsNotValid: "Girdiniz eposta adresi doğru değil",
            visitorNameUpdated: "Ziyaretci adı güncellendi",
            clickToEdit: "Düzenlemek için tıklayın",
            addEmail: "+ Email Adresi Ekle",
            addFullname: "+ Ad Ekle",
            partner: "Ref?",
            isIntegrated: "Entegrasyon?",
            agentCount: "Temsilci Sayısı",
            autoStartChat: "Otomatik Chat Başlangıcı",
            bubbleColor: "Chat Balonu Rengi",
            openFolder: "Aç",
            preDefined: "Temalar",
            customIcon: "Bilgisayarınızdan Yükleyin",
            theme: "Tema",
            themeSettings: "Tema Ayarları",
            bubbleSettings: "Chat Balonu Ayarları",
            bubbleIcon: "Chat Balonu Resmi",
            autoHideBubble: "Chat Balonunu Gizle",
            vtippyAutoHideBubble: "Temsilciler çevrimdışıyken chat balonunu gizler",
            closePreviewColors: "Tema Ayarlama Önizleme Kapat",
            previewColors: "Tema Ayarlama Önizlemeyi Aç",
            videoCalls: "Görüntülü Görüşmeler",
            filterLost: "Kaçan Konuşmalar",
            vtipyCustomLogin:
                "Ziyaretçileriniz sisteme bağlanırken giriş formunda istenecek bilgileri buradan özelleştirebilirsiniz.",
            vtipyLoginlessChat:
                "Ziyaretçileriniz sisteme bağlanırken giriş formu gösterilmez. Temsilciler ziyaretçilerin kişisel bilgilerini isteyerek kullanılır",
            loginlessChat: "Ziyaretçi Giriş Formu",
            imageUrl: "Resim",
            openImage: "Resmi Aç",
            writeFeedback: "Supsis ile  ilgili geri bildirimini buraya yazabilirsin.",
            feedbackFailed: "Geri bildirim gönderimi sırasında hata oluştu.",
            feedbackSuccessful: "Geri bildirim gönderimi başarılı.",
            sendFeedback: "Geribildirim Gönder",
            errorReport: "SUPSIS ile ilgili yaşadığınız sorunlar hakkında bize geri bildirimde bulunabilirsiniz.",
            sendErrorFeedBack: "Yaşadığınız sorunla ilgili bize geri bildirimde bulunun.",
            successImgUpload: "Resminiz başarıyla yünlendi",
            errorImgUpload: "Resminiz yüklenirken bir hata meydana geldi",
            chatBotEndStatics: "Chatbot Konusma Sonuçlandırma Oranı",
            videoCallDist: "Video Görüşme Dağılımı",
            deleteSite: "Site Silinsin mi?",
            departmentInfo: "Departman Bilgisi",
            infoAboutDepartment: "Departman hakkında kısa bilgi",
            deleteDepartmentQuestion: "Bu departmanı gerçekten silmek istiyor musunuz?",
            departmentDeleted: "Departman silindi",
            departmentTitle: "Departman Başlığı",
            updateDepartmentForm: "Departman Güncelleme Formu",
            newDepartmentForm: "Yeni Departman Kayıt Formu",
            newDepartment: "Yeni Departman",
            departmentSaved: "Departman Kaydedildi",
            departments: "Departmanlar",
            department: "Departman",
            chatTimingSettings: "Chat Süre Ayarları",
            assetOversize: "Göndermek istediğiniz dosyanın boyutu 2mb'den büyük olmamalıdır.",
            assetOversizeWithExt: "Dosya boyutu 10mb'tan küçük ve png,jpg formatında olmalıdır.",
            messageDeleted: "Bu mesaj silindi",
            filterVideoCall: "Görüntülü Görüşmeleri Gösterir",
            filterLostChat: "Kayıp Sohbetleri Filtreler",
            notificationText: "Supsis bildirimlerinin doğru şekilde çalışması için ",
            deniedText:
                "Bildirimleriniz kapalıdır ,  Müşterilerinizi kaçırmamanız için bildirimlerinizi açmanız gerekmektedir.",
            showNotificationGuide: "Detaylar için tıklayın",
            howToEnableNotification: "Bildirimleri Nasıl Etkinleştirebilirim",
            notificationOK: "Tamam",
            notificationCancel: "İptal",
            howToEnableNotificationInstruction1: "Tarayıcının adres çubuğundaki kilit ikonuna tıklayınız",
            howToEnableNotificationInstruction2: "İzinler kısmında 'Bildirimler' pasif gözüküyorsa aktifleştirin",
            howToEnableNotificationInstruction3:
                'İzinler kısmında "Bildirimler" gözükmüyorsa "Site Ayarlarına" tıklayınız',
            howToEnableNotificationInstruction4:
                'Site ayarları sayfasından "İzinler" bölümden "Bildirimler" iznini açınız',
            checkPaymentMethod: "Lütfen ödeme yönteminizi kontrol edin",
            pushNotificationEnabled: "Harika, Bildirim gönderimi etkin.",
            pushNotificationDenied: "Bildirim izinlerini reddettiniz",
            suspendedMessage: "Hesabınız askıya alındı",
            enableNotification: "Bildirimlerinizi açınız.",
            languageSettings: "Konuşma Dili",
            problemsSound:
                'Eğer bildirimler ile ilgili sorun yaşıyorsanız, tarayıcınızın adres çubuğundan (Resimde Gösterilen) kilit iconuna tıklayıp "Site Ayarları" alanından tıklayarak, açılan  bölümden "Ses" izin ver olarak değiştirebilirsiniz.',
            betweenRepresentative: "Bir temsilci yeni mesajı.",
            desktopNotifications: "Bildirimler",
            notificationDisable: "Temsilci ayarlarından masaüstü bildirimlerini kapatabilirsiniz.",
            notificationEnabled: "Supsis bildirimleri aktif.",
            newMessageAlert: "Yeni bir mesajınız var.",
            newConversationAlert: "Yeni bir konuşmanız var.",
            chatBot: "ChatBot",
            ticketResponse: "Representative Response:",
            archived: "Arşivle",
            chatbotChatCount: "CHATBOT",
            closeChat: "Mesajlaşmayı Bitir",
            ticket: "Ticket",
            formStep: "Form Adımı",
            menuStep: "Menü Adımı",
            contentStep: "İçerik Adımı",
            menuTitle: "Menü Başlığı",
            messageContent: "Mesaj İçeriği",
            goToLive: "Temsilciye Aktar",
            prevStep: "Önceki Adıma Dön",
            addButton: "Buton",
            addImage: "Görüntü",
            addText: "Metin",
            stepTitle: "Adım Başlığı",
            addTicket: "Ticket",
            formDescription: "Soru",
            addInput: "Soru",
            addRandomText: "Rastgele Metin",
            changeTitle: "Başlığı Değiştir",
            catalog: "Katalog Başlığı",
            openTheCatalog: "Kataloğu Aç",
            catalogNotOpen:
                "Katalog özelliği devre dışı. Müşterilerinize önceden hazırlanmış içeriklerle destek sağlamak için katalok özelliğini açabilirsiniz.",
            showCatalogCategories: "Katalog menünüsün chat balonunda gözükme durumunu değiştir.",
            showChatBot: "ChatBot menünüsün chat balonunda gözükme durumunu değiştir.",
            openCatalog: "Katalog",
            unreadMessages: "Okunmamış Mesajlar",
            personalFirstMsg: "Personel İlk Mesaj Ort.",
            personalRating: "Personel Puan Ort.",
            soundSettings: "Bildirim Ayarları",
            newPrivateMessage: "Özel Mesaj",
            newMessage: "Yeni Mesaj",
            newConversation: "Yeni Chat",
            newVisitor: "Yeni Ziyaretçi",
            chatPosition: "Chat Konumu",
            chatPositionSelect: "Konum Seçiniz",
            bottomLeft: "Sol Alt",
            left: "Sola yaslı",
            bottomRight: "Sağ Alt",
            right: "Sağa yaslı",
            mailorname: "E-Posta ya da İsim",
            breaksByTime: "Zamana göre mola sayıları",
            clPlaceholder: "Müşteri formunda gözükücek isim",
            fieldName: "Anahtar İsim",
            value: "Değer",
            addSetting: "Yeni Bir Ayar Ekle",
            globalSettings: "Genel Ayarlar",
            target: "Yük testi adresi",
            duration: "Yük testi süresi(sn)",
            arrivalCount: "Bot Sayısı(adet)",
            bootMaxLife: "Bir botun ayakta kalma süresi(sn)",
            startLoadTest: "Yük Testini Başlat",
            noClusterInstanceFound: "Sunucu bulunamadı",
            stopLoadTest: "Yük Testini Bitir",
            integrationDesc: "Aşağıdaki  tek satırlık kodu sitenize  eklemeniz yeterlidir.",
            integrationDemoCode: "Örnek entegrasyon demo kodu",
            integrationWindow: "Siteme Nasıl Entegre Yaparım ?",
            notIntegrated: "Entegrasyon",
            help: "Yardım",
            notIntegratedDesc:
                "Chat sistemini sitenize eklemediğinizi farkettik. Sitenize entegre edip ilk görüşmeyi başlattığınızda entegrasyonu tamamlamış olacaksınız. ENTEGRASYON KODU için tıklayınız",
            backToLogin: "Tekrar Giriş Yap",
            passwordlessLoginUnsuccessful:
                "Giriş başarısız.Giriş linkinin süresi dolmuş veya daha önce kullanılmış olabilir.",
            passwordlessLogin: "Şifresiz Giriş",
            loginWithEmail: "Eposta ile Giriş Yap",
            loginWithPassword: "Şifre ile Giriş Yap",
            enteringPasswordless: "Şifresiz Giriş Yapılıyor...",
            toMainPath: "Anasayfaya yönlendir",
            userRoleChanged: "Kullanıcı izinleriniz değişti. Devam etmek için ana sayfaya yönlendirileceksiniz.",
            passwordChangeSuccess: "Şifre Değiştirme İşleminiz Başarılı...",
            feedback: "Geri bildirim",
            showFeedbackHistory: "Geri bildirim gönderilmiş mesajları göster.",
            newSelfServiceSite: "Yeni Self Servis Site",
            subdomain: "Alt alan adı",
            rootUserEmail: "Kullanıcı Eposta",
            rootUserName: "Adınız",
            newVersion: "Yeni Sürüm Mevcut",
            newVersionShort: "Yeni Sürüm",
            bannedWordRestrict: "Yasaklı Kelime Engelleme",
            autoLoadIframe: "Canlı Trafik",
            autoLoadIframeDesc: "Iframe otomatik yükler ve tüm ziyaretci trafiği alır",
            bannedWordRestrictDesc:
                "Yasaklı Kelime Engelleme açık olduğunda temsilciler sisteme tanımlanana yasaklı kelimeleri ziyaretcilere yazması engellenir",
            agentDown: "Temsilci Düştü",
            delayChat: "Geciken Konuşma",
            tableSettingTippy: "Tabloda görünecek bilgileri burdan değiştirebilirsiniz.",
            tableSettings: "Tablo Ayarları",
            tableSettingsInfo:
                "Tabloda görünecek bilgileri burdan değiştirebilirsiniz. En fazla 7 tane sütun seçebilirsiniz",
            cityAndDistrict: "Şehir/İlçe",
            general: "Genel",
            home: "Anasayfa",
            successful: "Başarılı",
            forgetPasswordSent: "Parola sıfırlama maili gönderildi, e-mailinizi kontrol ediniz.",
            saturday: "Cumartesi",
            friday: "Cuma",
            thursday: "Perşembe",
            wednesday: "Çarşamba",
            tuesday: "Salı",
            monday: "Pazartesi",
            sunday: "Pazar",
            download: "Dosyayı İndir",
            calendarPassedTimeHour: "{hour} saat {name}",
            calendarPassedTime: "{hour} saat {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} saat {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Adlı Kullanıcının {sDate} Günü çalışma Takvimi",
            workSchedule: "{name} Adlı kullanıcın {sDate} - {eDate} Arası Çalışma Takvimi",
            calendar: "Takvim",
            noRating: "Hiç Puanlama Yapılmamış",
            rateDist: "Puan Dağılımı",
            distConversation: "Konuşma Dağılımı",
            totalWhatsappChatCount: "Whatsapp Chat Sayısı",
            statsByTime: "Zamana Göre Konuşma Sayıları",
            selectRep: "Bir temsilci seçin",
            allRepresentatives: "Bütün Temsilciler",
            avgRating: "Puan Dağılım ({point}) ({count} değerlendirme)",
            avgFirstMessageTime: "Ortalama ilk müdehale süresi ",
            totalBreakTime: "Mola Süresi",
            totalBreakNum: "Mola Sayısı",
            averageConTime: "Ortalama Konuşma Süresi",
            longestConTime: "En uzun Konuşma Süresi",
            shortestConTime: "En Kısa Konuşma Süresi",
            refresh: "Yenile",
            waitingReply: "Cevap Bekleyenler",
            organizationName: "Organizasyon Adı",
            messageSentErr: "Mesaj gönderilemedi, tekrar deneyiniz.",
            messageSent: "Mesaj gönderildi.",
            openPrivateChat: "Temsilciler arası konuşmayı aç",
            escKey: "Aktif konuşmayı gizle",
            privateChat: "Temsilciler Arası Konuşma Paneli",
            multiModeAlertDesc:
                'SUPSIS başka bir pencerede açık. SUPSIS\'ı bu pencerede kullanmak için "Burada Kullan"a tıklayın.',
            useHereText: "Burada Kullan",
            brandVisibility: "SUPSIS marka etiketi chat balonunda gözükür",
            focusInput: " İmleci aktif olan konuşmanın yazma alanına odaklar",
            send: "Gönder",
            notYet: "Henüz değil",
            sending: "Gönderiliyor",
            onlyRepresentative: "Mesajınız sadece temsilciler tarafından görülecektir.",
            yourMessage: "Mesajınız",
            notValid: "Sadece harf girebilirsiniz.(Tek karakter). e,d,f,z,a,x,c,v,w,t,n harfleri geçersizdir",
            forMacUsers: " Mac kullanıcıları Control(⌃) tuşunu kullanabilir",
            basePriceValue: "Taban Fiyat",
            basePriceDiscount: "İndirim",
            basePriceCurrency: "Para Birimi",
            customerDBEnabled: "Veritabanı Seçimi: Müşterinin Kendi Veritabanı Sunucusu Kullan",
            customerDBDisabled: "Veritabanı Seçimi: Supsis Veritabanı Sucunusu Kullan",
            mongoConnectionString: "Mongo Bağlantısı",
            whatsappBasePriceValue:"Whatsapp Taban Fiyatı",
            clientAddress: "İstemci Adresi",
            customerClientAddress: "Müşteri İstemci Adresi",
            apiAddress: "Api Adresi",
            socketAddress: "Soket Adresi",
            backendAddress: "BackEnd Adresi",
            panelLogoUrl: "Panel Logo Adresi",
            panelCustomCssUrl: "Özel Panel Css Adresi",
            customerLogoUrl: "Müşteri Logo Adresi",
            customerCssUrl: "Müşteri css Adresi",
            siteAlias: "Site Adı",
            language: "Dil",
            features: "Özellikler",
            represantativeSettings: "Temsilci Ayarları",
            chatBalloonTehemeSettings: "Sohbet Balonu ve Tema Ayarları",
            customLoginFormSettingsTitle: "Ziyaretçi Giriş Formunu Özelleştir",
            addNewField: "Yeni Alan Ekle",
            editField: "Alanı Düzenle",
            typeHere: "Buraya yaz",
            pco: "PÇO",
            perPage: "/sayfa",
            startFilter: "Aramaya başla",
            showMyChats: "Bana Atananları Göster",
            showOnlineAgents: "Sadece Çevrimiçi Olanları Göster",
            showWaitingChats: "Temsilci Bekleyenleri Göster",
            newTitleContent: "Başlık Ekle",
            roleName: "Rol Adı",
            error: "Hata",
            contentType: "İçerik Tipi",
            contentTitle: "İçerik Başlığı",
            newSiteForm: "Yeni Site Kayıt Formu",
            updateSiteForm: "Site Güncelleme Formu",
            newBannedWordForm: "Yeni Yasaklı Kelime Kayıt Formu",
            updateBannedWordForm: "Yasaklı Kelime Güncelleme Formu",
            newWelcomeMessageForm: "Yeni Karşılama Mesajı Kayıt Formu",
            updateWelcomeMessageForm: "Karşılama Mesajı Güncelleme Formu",
            newDefaultContentForm: "Yeni Hazır İçerik Kayıt Formu",
            updateDefaultContentForm: "Hazır İçerik Güncelleme Formu",
            newSubjectForm: "Yeni Konu Kayıt Formu",
            updateSubjectForm: "Konu Güncelleme Formu",
            showIntro: "Tanıtımı Göster",
            showChatColorMeaning: "Sohbet Renkleri",
            options: "Seçenekler",
            resetPassword: "Şifreyi yenile",
            audioLevel: "Sesli uyarı ses seviyesi",
            privateChatNotificationSound: "Bildirim sesi",
            continue: "Devam et",
            newRoleForm: "Yeni Rol Kayıt Formu",
            updateRoleForm: "Rol Güncelleme Formu",
            newUserForm: "Yeni Kullanıcı Kayıt Formu",
            updateUserForm: "Kullanıcı Güncelle Formu",
            changeOSRForm: "Çevrimdışı Mesaj Değiştir",
            tooltipOSRForm: "Çevrimdışı mesajı değiştireblirsiniz.",
            newOSRForm: "Çevrimdışı Destek Formu",
            newOSRMessages: "Çevrimdışı Mesaj Ekle",
            updateOSRForm: "Çevrimdışı Güncelleme Formu",
            osrTitle: "Başlık",
            osrTitleDescription: "Çevrimdışı destek formu başlığı ekleyebilirsiniz",
            osrContent: "İçerik",
            osrContentDescription: "Çevrimdışı destek formu içeriği ekleyebilirsiniz",
            hello: "merhaba dünya",
            date: "Tarih",
            startDate: "Başlangıç Tarihi",
            finish: "Bitiş",
            start: "Başlangıç",
            search: "Ara",
            endDate: "Bitiş Tarihi",
            representative: "Temsilciler",
            representative_: "Temsilci",
            star: "Yıldız",
            filter: "FİLTRELE",
            reset: "SIFIRLA",
            dailyChatList: "Günlük Konuşma Listesi",
            dailyChatDuration: "Günlük Konuşma Süreleri",
            chatDuration: "Konuşma Süresi",
            dailyChatGraph: "Günlük Konuşma Grafiği",
            ok: "Tamam",
            cancel: "Vazgeç",
            chatCount: "Konuşma Sayısı",
            shortest: "En Kısa",
            longest: "En Uzun",
            average: "Ortalama",
            count: "Adet",
            averagePoint: "Ortalama Puan",
            pointDist: "Puan Dağılımı",
            point: "Puan",
            filters: "Filtreler",
            totalCustomer: "Toplam Müşteri",
            avResponseTime: "Ort. İlk Müdahale Zamanı",
            breakDuration: "Mola Süresi",
            breakCount: "Mola Adeti",
            active: "Aktif",
            passive: "Pasif",
            userForm: "Kullanıcı Formu",
            startChat: "Chat Başlat",
            profile: "Profil",
            name: "Ad",
            number: "Numara",
            username: "Kullanıcı Adı",
            updateUserName: "Kullanıcı Adı Güncelle",
            email: "E-Posta",
            password: "Şifre",
            oldPassword: "Eski Şifre",
            newPassword: "Yeni Şifre",
            passwordAtLeast: "Şifre (en az {num} karakter)",
            passwordRepeat: "Şifre Tekrar",
            changePassword: "Şifre Değiştir",
            status: "Durum",
            enableState: "Aktif?",
            douYouWishToDeleteUser: "Bu kullanıcıyı gerçekten silmek istiyor musunuz?",
            userDeleted: "Kullanıcı silindi",
            userSaved: "Kullanıcı kaydedildi.",
            oldPasswordError: "Eski şifre hatalı, lütfen kontrol edin.",
            userVolumeUpdated: "Ses ayarı güncellendi.",
            save: "Kaydet",
            update: "Güncelle",
            addNewMenu: "Yeni Menü Ekle",
            addNewContent: "Yeni İçerik Ekle",
            pleaseTitleEnter: "Lütfen başlık girin",
            like: "Beğenilme",
            disLike: "Beğenilmeme",
            users: "Kullanıcılar",
            allContacts: "Tüm Bağlantılar",
            allUsers: "Tüm Temsilciler",
            allSites: "Tüm Siteler",
            newUser: "Yeni Kullanıcı",
            noNewUser: "Henüz bir kullanıcı yok.",
            noNewAdminUser: "Henüz bir admin kullanıcı yok.",
            noRoleFound: "Henüz bir rol yok.",
            noBannedWordFound: "Henüz yasaklı kelime yok.",
            noWelcomeMessageFound: "Henüz karşılama mesajı yok.",
            noSubjectFound: "Henüz konu yok.",
            noVisitorFound: "Ziyaretci bulunamadı.",
            noContactFound: "Rehber bulunamadı.",
            sendResponse: "Cevap Yaz",
            delete: "Sil",
            noRePresentativeFound: "Temsilci bulunamadı.",
            noLiveSupportFound: "Henüz canlı destek kaydı yok.",
            noBannedVisitorFound: "Henüz bir yasaklı ziyaretçi yok.",
            removeBanDescription: "Yasağı kaldır",
            editThisItem: "Bu kaydı güncelle",
            removeThisItem: "Bu kaydı sil",
            role: "Rol",
            newRolePlaceHolder: "Yeni rol eklemek için tıklayınız...",
            autoChatAssignLimit: "Otomatik Konuşma Atama Limiti",
            chatAssignInfo: "-1 = Sistem varsayılanı, 0 = Hiç atama yapılmaz, >0 = Verilen değer kadar atama yapılır.",
            relatedDepartments: "İlgili Departmanlar",
            subjectInfo: "Konu seçilmemesi halinde tüm konulara izin verilecektir..",
            archive: "Arşiv",
            offlineSupportRequests: "Çevrimdışı Destek",
            offlineModeMessage: "Çevrimdışı Mesaj",
            offlineMode: "Çevrimdışı Mod",
            first: "İlk",
            last: "Son",
            query: "Aramaya Başla",
            clean: "Temizle",
            loading: "Yükleniyor",
            loadMore: "Daha fazla yükle",
            noMessage: "Hiç mesaj yok...",
            selectChat: "Konuşma Seçiniz",
            noMessageInChat: "Bu konuşmada herhangi bir mesaj bulunamadı",
            userInfo: "Kullanıcı Bilgileri",
            chatId: "Konuşma ID",
            visitingPage: "Ziyaret Edilen Sayfa",
            osAndBrowser: "İşletim Sistemi & Tarayıcı",
            customerClientVersion: "Müşteri Versiyonu",
            visitorFeedback: "Müşteri Geri Bildirimi",
            nameSurname: "Adı Soyad",
            chats: "Konuşmalar",
            bannedVisitors: "Yasaklı Ziyaretçiler",
            country: "Ülke",
            city: "Şehir",
            cityDistrict: "İl İlçe",
            browser: "Tarayıcı",
            os: "İşletim Sistemi",
            ipAddress: "IP Adresi",
            connectionDate: "Bağlantı Zamanı",
            transaction: "İşlem",
            banRemoved: "Engelleme kaldırıldı.",
            bannedWords: "Yasaklı Kelimeler",
            newBannedWord: "Yeni Yasaklı Kelime",
            noBannedWord: "Henüz bir engelli kelime yok.",
            bannedWordForm: "Yasaklı Kelime Formu",
            word: "Kelime",
            bannedWordAndWordGroup: "Yasaklı kelime / kelime grubu",
            doYouWishToDeleteBannedWord: "Bu yasaklı kelimeyi gerçekten silmek istiyor musunuz?",
            doYouWishToOfflineSupportRequest: "Bu mesajı silmek istiyor musunuz?",
            bannedWordSaved: "Yasaklı kelime kaydedildi",
            deletedSuccessfully: "Başarıyla silindi",
            deleteErrorMsg: "Silme işlemi gerçekletirilemedi, tekrar deneyiniz",
            socketError: "Sockete Bağlantı sorunu. Lütfen sayfayı yenileyip tekrar deneyiniz",
            socketConnecting: "Sunucu ile bağlantı kuruluyor",
            offlineModeDescription: "Sistem kapalı, müşteriler canlı desteğe erişemeyecek.",
            offlineModeSettingsDescription: "Ayarlar menüsünde 'Çevrimdışı Mod' özelliğini kontrol edin.",
            offlineModeUser: "Sistemde en az bir online temsilci olması gerekir.",
            adminCannotConnectSocket: "Adminler sokete bağlanamaz.",
            liveSupport: "Canlı Destek",
            siteVisitors: "Site Ziyaretçileri",
            visitors: "Ziyaretçiler",
            thoseConnectedToLiveSupport: "Canlı Desteğe Bağlananlar",
            visitorHistory: "Ziyaretçi Geçmişi",
            privateMessage: "Özel Mesaj",
            addRepresentative: "Temsilci Ekle",
            forwardRepresentative: "Temsilciye Yönlendir",
            keyboardShortcuts: "Klavye Kısayolları",
            chatColorMeanings: "Konuşma Renk Anlamları",
            connLostCheckInternet: "Bağlantınız koptu. Lütfen internet bağlantınızın olduğundan emin olunuz.",
            wishToEndThisChat: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            defaultContents: "Hazır İçerikler",
            newDefaultContent: "Yeni Hazır İçerik",
            newCTRLContent: "CTRL İçeriği Ekle",
            newALTContent: "ALT İçeriği Ekle",
            newTABContent: "TAB İçeriği Ekle",
            title: "Başlık",
            shortcutChar: "Kısayol Karakteri",
            pickOne: "Birini seçin",
            writeSomething: "Bir karakter yazın (a-z|0-9)",
            letterSequence: "Harf Serisi",
            exampleText: "Örnek: fut -> futbol",
            anyChar: "Herhangi bir karakter",
            shorcutKey: "Kısayol tuşu",
            content: "İçerik",
            shortcutName: "Kısayol Adı",
            type: "Tip",
            shortcut: "Kısayol",
            deleteContentQuestion: "Bu hazır içeriği gerçekten silmek istiyor musunuz?",
            defaultContentDeleted: "Hazır içerik silindi.",
            defaultContentSaved: "Hazır içerik kaydedildi.",
            defaultContentForm: "Hazır İçerik Formu",
            contentMoved: "İçerik taşındı.",
            cannotMoveFullParent: "Bu elemanı taşıyamazsınız",
            yourEmail: "E-Posta Adresiniz",
            yourName: "Adınız",
            lostPassword: "Şifremi Unuttum",
            login: "Giriş",
            forgotPassword: "Parolamı Unuttum",
            multipleSession: "Başka bir yerde oturum açtınız.",
            notAuthorizedToDisplayPage: "Bu sayfayı görüntülemek için izniniz bulunmuyor!",
            permissions: "İzinler",
            newPermission: "Yeni İzin",
            permissionForm: "İzin Formu",
            displayTitle: "Görüntüleme başlığı",
            key: "Anahtar",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: "Bu izni gerçekten silmek istiyor musunuz?",
            permissionDeleted: "İzin silindi.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Yeni Rol",
            selectARole: "Bir Rol Seç",
            yes: "Evet",
            no: "Hayır",
            fullAuth: "Tam Yetki",
            roleDeleted: "Rol silindi.",
            roleSaved: "Rol kaydedildi.",
            roleForm: "Rol Formu",
            roles: "Roller",
            settings: "Ayarlar",
            selectTopic: "Departman Seçimi",
            autoCallTransfer: "Otomatik Görüşme Aktarımı",
            customerTyping: "Kullanıcı Yazıyor",
            typing: "Yazıyor",
            agentTyping: "Temsilci  Yazıyor",
            disconnectTime: "Konuşmayı Sonlandırma Süresi (sn)",
            tippyDissconnectTime: "Hareketsiz durumdaki konuşmayı kaç saniye sonra kapatılacağını ayarlar",
            queueNumberVisibleFeature: "Ziyaretciye Sırada Bekleyen Kişi Sayısını Göster",
            privateChatEnabled: "Temsilciler Arası Sohbeti Göster",
            delayedTalkTime: "Gecikme Süresi(sn)",
            employeeAverageChatCount: "Personel chat oranı için ortalama konuşma sayısı",
            customerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            autoAssignLimit: "Otomatik Atama Limiti",
            wasted: "Boşa Düşme Süresi (sn)",
            settingsSaved: "Ayarlar kaydedildi.",
            settingFormWrong: "Girdiğiniz veriler hatalıdır, kontrol edip tekrar deneyiniz",
            delayTime: "Gecikme Zamanı (sn.)",
            sites: "Siteler",
            newSite: "Yeni Site",
            noSiteYet: "Henüz bir site yok.",
            siteAddress: "Site Adresi",
            customerRepLimit: "Müşeri Temsilcisi Limiti",
            siteSaved: "Site kaydedildi.",
            siteSaveError: "Site oluştururken hata oluştu.",
            subjects: "Konular",
            newSubject: "Yeni Konu",
            noSubject: "Henüz bir konu yok.",
            subject: "Konu",
            subjectTitle: "Konu Başlığı",
            description: "Açıklama",
            infoAboutSubject: "Konu hakkında kısa bilgi",
            deleteSubjectQuestion: "Bu konuyu gerçekten silmek istiyor musunuz?",
            subjectDeleted: "Konu silindi",
            subjectSaved: "Konu kaydedildi.",
            osrFromMessageSaved: "Çevrimdışı mesaj kaydedildi.",
            welcomeMessages: "Karşılama Mesajları",
            newWelcomeMessages: "Yeni Karşılama Mesajı",
            noWelcomeMessage: "Henüz bir karşılama mesajı yok.",
            welcomeMessageContent: "Karşılama mesaj içeriği",
            makeChoice: "Bir seçim yapın...",
            welcomeMessage: "Hoşgeldin Mesajı",
            repLoggedIn: "Temsilci oturum açtı",
            loginMessage: "Oturum kapatma mesajı",
            message: "Mesaj",
            deleteWelcomeMessageQuestion: "Bu karşılama mesajını gerçekten silmek istiyor musunuz?",
            welcomeMessageDeleted: "Karşılama mesajı silindi",
            welcomeMessageSaved: "Karşılama mesajı kaydedildi.",
            welcomeMessageForm: "Karşılama Mesajı Formu",
            noRep: "Henüz bir temsilci yok.",
            addChat: "Görüşmeye Ekle",
            forwardChat: "Görüşmeyi Yönlendir",
            ago: "önce",
            repName: "Temsilci Adı",
            lastOnline: "Son Bağlantı/Online zamanı",
            lastStatusChange: "Son Durum Değişikliği",
            activeChat: "Aktif konuşma",
            userMaxCapacity: "Max Chat Kapasitesi",
            noActiveChat: "Aktif konuşma yok.",
            watch: "İZLE",
            join: "KATIL",
            open: "KONUŞMAYI AÇ",
            directMessage: "ÖZEL MESAJ",
            block: "ENGELLE",
            transactions: "İşlemler",
            informations: "Bilgiler",
            visitStart: "Ziyaret Başlangıcı",
            fullName: "Adı Soyadı",
            waitChatTime: "Bekleme Süresi/Chat Süresi",
            blockUserConfirm: "Bu kişiyi gerçekten engellemek istiyor musunuz?",
            messaging: "Mesajlaşma",
            hideChat: "Konuşmayı Gizle",
            block_: "Engelle",
            privateMessage_: "Gizli Mesaj",
            assignRep: "Temsilci Ata",
            joinChat: "Konuşmaya Dahil Ol",
            forwardRep: "Yönlendir",
            leaveChat: "Görüşmeden Ayrıl",
            endChat: "Görüşmeyi Sonlandır",
            translatedTextDescription: "Amazon  bu mesajın {from} -> {to} çevirisini yapmıştır.",
            autoTranslate: "Otomatik Tercüme",
            translateThisMessage: "Bu mesajı çevir",
            autoTranslateDetectedDesc:
                "Ziyaretçi {visitorLanguage} dilinde konuşuyor. Otomatik Tercümeyi Etkinleştirmek İçin Buraya Tıklayın",
            on: "Açık",
            off: "Kapalı",
            copy: "Kopyala",
            prevChats: "Önceki Konuşmalar",
            noShortCut: "Kısayol yok",
            leaveChartConfirm: "Konuşmadan ayrılmak istediğinize emin misiniz?",
            endChatConfirm: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            chatBar: "Konuşma Gösterge Paneli",
            endConversation: "Görüşmeyi Sonlandır",
            onlyOneRep: "Bu konuşmadaki tek temsilci sizsiniz!",
            chatList: "Konuşma Listesi",
            unreadTitle: "Okunmamış",
            visitorLeftTitle: "Ziyaretci Çıkış",
            activeChatTitle: "Aktif Konuşma",
            autoAssignedTitle: "Otomatik Atanmış",
            watchModeTitle: "İzleme Modu",
            lostChat: "Temsilci Bağlantısı Kopmuş",
            repLostConn: "Temsilci konuşmadan koptu ise konuşma arkaplanı pembe olur.",
            chatWidthDelay: "Gecikmeye Düşen Chat",
            repChatWidthDelay:
                "Sistemde aktif temsilci olmadığında veya yoğunluktan dolayı ziyaretçi alınmadığında konuşma arka planı yeşil rengi olur. ",
            unreadMsg: "Okunmamış Mesaj Varsa  arkaplan açık mavi olur.",
            visitorLeftChat: "Ziyaretçi konuşmadan ayrıldı ise arkaplan koyu gri olur.",
            activeChatMsg: "Konuşma aktif ise arkaplan yeşil olur",
            autoAssignMsg: "Otomatik atama ile atandı ve konuşmaya daha bakılmadı ise arkaplan hardal olur",
            watchModeMsg: "İzleme modunda açıldı ise arkaplan kırmızı olur",
            online: "Çevrimiçi",
            beRightBack: "Hemen Dönecek",
            away: "Hemen Dönecek",
            busy: "Meşgul",
            offline: "Çevrimdışı",
            logout: "Çıkış Yap",
            forWindows: "Windows İçin",
            forMac: "Mac İçin",
            nextChatFromActive: "Aktif konuşmadan bir sonraki konuşmaya geç",
            previousChatFromActive: "Aktif konuşmadan bir önceki konuşmaya geç",
            hideActiveChat: "Aktif konuşmayı gizle",
            closeActiveChat: "Aktif konuşmayı bitir",
            firsthiddenChat: "En çok beklemiş müşterinin konuşmasına bağlan",
            firstChatWaiting: "Cevap bekleyen konuşmaya geçiş yap",
            previousOpenedChat: "Sıra farketmeksizin, bir önce açılan konuşmaya geçiş yap",
            historyDetails: "Geçmiş Detayları",
            chat: "Konuşma",
            chatNotFound: "Konuşma bulunamadı.",
            visitorInfo: "Ziyaretçi Bilgileri",
            timeSpent: "Geçen Süre",
            noActiveVisitors: "Aktif ziyaretçi yok",
            select: "Açılır Menü",
            fullname: "Tam Ad",
            text: "Metin",
            numeric: "Sayısal",
            phone: "Telefon",
            optionsPlaceholder: "Seçenek değeri",
            selectField: "Açılır Menü eklemek istiyorsanız tıklayın",
            fullnameField: "Tam Ad alanı eklemek istiyorsanız tıklayın.",
            textField: "Metin alanı eklemek istiyorsanız tıklayın.",
            numericField: "Sayısal alanı eklemek istiyorsanız tıklayın.",
            phoneField: "Telefon alanı eklemek istiyorsanız tıklayın.",
            departmentField: "Bölüm eklemek istiyorsanız tıklayın",
            emailField: "Email alanı eklemek istiyorsanız tıklayın.",
            visible: "Görünür",
            required: "Zorunluluk",
            label: "Açıklama",
            totalConnected: "Konuşma Sayısı",
            missedChat: "Kaçan Konuşma Sayısı",
            workTime: "Mesai Süresi",
            closedChatCount: "Kapatılan Konuşmalar",
            activeConvo: "Aktif konuşulan",
            notAnswered: "Henüz cevap verilmemiş",
            delayedConvo: "Gecikmiş Konuşmalar",
            leavingRep: "Ayrılan temsilci",
            staffRate: "Personel Çalışma Oranı",
            customLoginAlert: "Formunuzda  en az 1 adet görünür alan olmak zorundadır.",
            atLeastOneLanguage: "En az bir dil açıklaması olmak zorundadır.",
            requiredField: "Bu alan zorunludur.",
            notRequiredField: "Bu alan zorunlu değildir.",
            visibleField: "Bu alan formda gözükür.",
            notVisibleField: "Bu alan formda gözükmez.",
            connectServer: "Sunucuya bağlısınız",
            disconnectServer: "Sunucu ile bağlantınız kesildi",
            liveChatOff: "Canlı Destek Kapalı",
            visitorScreen: "Ziyaretçi Ekranı",
            showHint: "İpucu Göster",
            dontShowHint: "İpucu Gösterme",
            liveChatOn: "Canlı Destek Açık",
            nightModeOff: "Gece Modu Kapalı",
            nightModeOn: "Gece Modu Açık",
            edit: "Düzenle",
            deleteField: "Sil",
            arrow_upward: "Yukarı Taşı",
            arrow_downward: "Aşağı Taşı",
            doubleClickEdit: "Düzenlemek için iki kere tıklayın veya düzenle butonuna basın.",
            newCatalogCategory: "Yeni Katalog Kategorisi",
            childCreate: "Alt içerik oluşturmak için tıklayın",
            updateCatalogCategoryFrom: "Katalog Kategori Güncelle Formu",
            newCatalogCategoryFrom: "Yeni Katalog Kategori Formu",
            catalogMenu: "Menü",
            catalogContent: "İçerik",
            catalogCategoryName: "Katalog kategori adı",
            newCatalogContentFrom: "Yeni Katalog İçerik Formu",
            catalogContentName: "Katalog içerik adı",
            catalogCategorySaved: "Katalog katagorisi kaydedildi",
            catalogCategoryDeleted: "Katalog kategorisi silindi.",
            catalogCategoryRate: "İçerik Puanı",
            catalogContentFeature: "Katalog Özelliği",
            vtipyAudioLevel: "Bildirim seslerini kısmanız veya açmanız için kullanılır.",
            vtipyOrganizationName: "Organizasyon adını değiştirip güncelleyebilirsiniz.",
            vtipyBrandVisibility: "Supsis etiketinin, chat balonunda gösterip gösterilmeyeği ayarıdır.",
            vtipyBrandVisibilityForced: "Yalnızca ProPlan kullanıcıları değiştirebilir!!",
            vtipyClientDefault: "Temsilci sayfası dilini buradan değiştirebilirsiniz.",
            vtipyCustomerClientDefault: "Müşteri(Chat) sayfasının dilini buradan değiştirebilirsiniz.",
            vtipyVisitorPreferredLang: "Müşteri(Chat) sayfasında konuşma dilini seçebilir.",
            vtipyCustomerClientLanguageDetect: "Müşteri(Chat) sayfasının dilini otomatik olarak algılıyabilirsiniz.",
            vtipySelectTopic:
                "Müşterilerin seçtiği konulara göre departmanlara(konulara) yönlendirmek zorunlu hali gelir.",
            vtipyAutoCallTransfer: "Müsait olan temsilcilere, bekleyen görüşmeleri otomatik atar.",
            vtipyCustomerTyping: "Müşterinin chat ekranında yazdıklarını, temsilci chat ekranında görmenizi sağlar.",
            vtipyAgentTyping: "Temsilcinin yazma durumunu müşteri baloncuğunda gösterir.",
            vtipyQueueNumberVisibleFeature:
                "Temsilcilerin yoğun oldukları zamanda, bağlanmak isteyen müşterilere kaçıncı sırada olduklarını gösterir.",
            vtipyPrivateChatEnabled: "Temsilciler arası konuşma panelini gösterir.",
            vtipyDelayedTalkTime:
                'Bu süre zarfında konuşmaya hiçbir temsilci bağlanmadığında "Geciken Konuşma" olarak etiketlenir.',
            vtipyOfflineMode: "Sistemi çevrim dışı moda almanızı sağlar.",
            vtipyAutoAssignLimit: "Temsilciye otomatik kaç tane müşteri(chat) atama yapılacağını belirler.",
            vtipyCustomerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            tippyDisconnectTime: "Müşteri bağlantısı koptuktan sonra chatin kapanma süresi (sn).",
            changeSettings: "Global Ayarı Değiştirin",
            totalBg: "TOPLAM",
            activeBg: "AKTİF",
            watchBg: "İZLEME",
            waitingBg: "BEKLEYEN",
            lateBg: "GECİKENLER",
            freeBg: "BOŞTA",
            maxCapacityBg: "MAKS KAPASITE",
            addNewSettings: "Yeni Bir Global Ayar Ekleyin",
            darkMode: "Gece Modu",
            clientDefault: "Panel varsayılan dil",
            customerClientDefault: "Müşteri kısmı varsayılan dil",
            customerClientLanguageDetect: "Müşteri kısmı dili otomatik algıla",
            visitorPreferredLang: "Müşteri konuşma dilini seçsin",
            preferredThemeColor: "Konuşme Ekranı Tema Tercihi",
            detail: "İncele",
            langSetting: "Dil Ayarı",
            supportUs: "Bize Ulaşın (Canlı Destek)",
            changeLang: "Dil Değiştir",
            fontSizeSetting: "Ekran Büyütme Ayarı",
            changeLangDesc: "Uygulama dilini {code} olarak ayarlar.",
            trLang: "Türkçe",
            enLang: "İngilizce",
            fieldRequired: "{field} alanı gereklidir.",
            selectALanguage: "Bir Dil Seçiniz",
            selectATheme: "Bir Tema Seçiniz",
            responseForm: "Cevap Formu",
            clientRequestInfo: "Müşteri Talep Bilgisi",
            createdDate: "Oluşturma Tarihi",
            descMessage: "Mesaj",
            new: "Yeni",
            lastLoginPlatform: "Platform",
            requiredFieldField: "Bu alan zorunludur",
            catalogCategoryMenu: "Katalog Kategori menüsü ekle",
            catalogCategoryLeaf: "Katalog kategorisi alt menüsü ekle",
            selectAllPermission: "Tümünü Seç",
            catalogCategories: "Katalog",
            copiedClipboard: "Panoya kopyalandı",
        },
        adminUser: {
            newAdminUserForm: "Yeni Admin Kullanıcısı Kayıt Formu",
            updateAdminUserForm: "Admin Kullanıcısı Güncelleme Formu",
            adminUsers: "Admin Kullanıcılar",
            newAdminUser: "Yeni Admin Kullanıcı",
            noAdminUser: "Henüz bir admin kullanıcı yok.",
            adminUserName: "Admin Kullanıcı Adı",
        },
        report: {
            detailReport: "Detaylı Rapor",
            dailyReports: "Günlük Raporlar",
            pointBasedReports: "Puan Bazlı Raporlar",
            personDateBasedPointReport: "Kişi ve Gün Bazlı Puan Raporu",
            personDateBasedReport: "Kişi ve Gün Bazlı Rapor",
            personBasedReport: "Kişi Bazlı Raporlar",
            personAndDateBasedGraph: "Kişi ve Gün Bazlı grafiği",
            noReport: "Rapor Yok",
            reports: "Raporlar",
            totalBar: "Toplam",
        },
        stats: {
            total: "Sistemdeki aktif konuşmaların sayısıdır.",
            active: "Size ait olan aktif konuşmaların sayısıdır.",
            waiting: "Temsilci atanmayı bekleyen yeni aktif konuşma sayısıdır.",
            late: "Belli bir süre geçmiş  ve temsilci atanmayı bekleyen yeni konuşmaların sayısıdır.",
            free: "Temsilcisi çıkış yaptıktan sonra yeni temsilci atamayı bekleyen konuşmaların sayısıdır.",
            pco: "[Personel Çalışma Oranı] : Sistemdeki çevrimiçi temsilcilerin toplam alabildiği konuşma sayısının doluluk oranınıdır. ",
            maxCapacity: "Sistemin bekletmeden temsilci atayabileceği maksimum chat sayısıdır",
            chatbot: `Chatbot'un aktif konuşma sayısı`,
        },
        time: {
            today: "Bugün",
            yesterday: "Dün",
            lastWeek: "Geçen Hafta",
            currentWeek: "Bu Hafta",
            currentMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last30Day: "Son 30 gün",
            allTime: "Tüm Zamanlar",
            custom: "Farklı Bir Zaman",
        },
        fastWizard: {
            tellUsMore: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            moreInfo: "Genel Ayarlar",
            display: "Tema Ayarları",
            availability: "Temsilci Çalışma Saatleri",
            preview: "Önizleme",
            installCode: "Kurulum",
            previous: "Önceki Adım",
            setupSupsisLiveChat: "SUPSIS LIVE Hızlı Kurulum",
            continue: "Sıradaki Adım",
            completeInitialize: "Hızlı Kurulumu Tamamla",
            completedMessage: "SUPSIS Live Hızlı Kurulumu Başarıyla Gerçekleştirildi.",

            websiteIntegration: "Supsis Live entegrasyonu için web sitenizin adresi",

            customizeLiveChat: "Canlı Sohbetinizi Özelleştirin",
            createBrandedExperience: "Ziyaretçileriniz için markalı bir sohbet deneyimi oluşturun.",
            chatColor: "Chat Rengi",
            chooseChatColor: "Bir Renk Seçin.",
            chatBubble: "Chat Balonu",
            selectBubble: "Bir Chat Balonu Seçin",
            chatBubbleColor: "Chat Balonu Rengi",
            selectChatBubbleColor: "Chat Balonu Rengini Seçin",
            customSelection: "Özel Seçim:",

            onlineSupportVisitorTime: "Ziyaretçilerinize hangi zaman aralıklarında hizmet sağlarsınız?",
            channelAvailability: "Çevrimci Zamanlama",
            availability724: "7/24 Sürekli Hizmet",
            basedOnTeam: "Temsilci Çalışma Saatleri Dahilinde",
            basedOnTeamExplanation:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür",
            customHours: "Özel Çalışma Saatleri",
            customHoursExplanation: "Kendi Çalışma Saatlerinizi Belirleyin",
            customHoursTimezone: "Bölgesel Zaman Dilimi:",
            customHoursFrom: "Başlangıç:",
            customHoursTo: "Bitiş:",
            customHoursAddHours: "+Saat Ekle",

            previewDesktop: "Masaüstü",
            previewIpad: "Tablet",

            installationAndInstructions: "Kurulum & Talimatlar",
            installationTrackingCode: "İzleme kodunu web sitenize yükleyin",
            installationTrackingCodePlease:
                "Lütfen kodu, SUPSIS Canlı sohbeti etkinleştirmek istediğiniz herhangi bir sayfada {bodyTag} etiketinin bitiminden hemen önce aşağıdaki talimatlara uygun olarak yapıştırın.",
            installationInstructionsJavascript:
                " Yukarıda verilen entegrasyon kodunu {bodyTag} etiketi içerisinde kapanıştan hemen öncesine yapıştırın.",
            installationInstructionsShopify1: "1. Shopify panelinize giriş yapın",
            installationInstructionsCopy: "Kopyala",
            installationInstructionsCoppyMessage: "Entegrasyon komutları panoya kopyalandı",
            installationInstructionsShopify2:
                "2. Online Store > Themes > Actions 'a gidin,altındaki açılır menüden  Current Theme > Edit code >theme.liquid 'e ilerleyin",
            installationInstructionsShopify3:
                "3.Yukarıda verilen entegrasyon kodunu, theme.liquid scriptinin sonundaki {bodyTag} etiketinin hemen önüne yerleştirin.",
            installationInstructionsIdeaSoft1: "1. Bayi panelinize giriş yapınız.",
            installationInstructionsIdeaSoft2: "2. Ayarlar -> SEO -> Arama Motoru Servisleri adımını takip ediniz.",
            installationInstructionsIdeaSoft3:
                '3. Takip Kodu  kısmından "Meta Tag ile Site Doğrulama"  seçeneğini seçiniz.',
            installationInstructionsIdeaSoft4:
                "4. Açılan kutuya yukarıdaki entegrasyon kodunu kopyalayıp yapıştırın ve kaydediniz.",
            installationInstructionsIdeaSoft5:
                '5. Ayarlar -> Optimizasyonlar -> "Ön Belleği Temizle" butonuna basınız. Entegrasyon tamamlanmıştır.',
            installationInstructionsWordPress1: "1. WordPress yönetici panelinize giriş yapın",
            installationInstructionsWordPress2: "2. Görünüm > Tema Düzenleyici'ye gidin",
            installationInstructionsWordPress3:
                "3. (en sağda) Tema Dosyaları altında, Tema Altbilgisini (footer.php)'yi bulun ve seçin",
            installationInstructionsWordPress4:
                "4.Yukarıdaki entegrasyon kodunu alttaki {bodyTag} etiketinin önüne yapıştırın.",
            installationInstructionsWordPress5: "5. Değişiklikleri kaydetmek için Dosyayı Güncelle'yi tıklayın",
            installationInstructionsOpenCart1: "1. Opencart admin panelinize giriş yapın",
            installationInstructionsOpenCart2: "2. Tasarım > Tema Düzenleyici'ye gidin",
            installationInstructionsOpenCart3:
                "3. 'common' klasörünü seçin ve içerisindeki 'header.twig' dosyasını açın.",
            installationInstructionsOpenCart4:
                "4.Yukarıdaki entegrasyon kodunu, alttaki {headTag} etiketinin önüne yapıştırın.",
            installationInstructionsOpenCart5: "5. Kaydet butonuna tıklayın",
            installationInstructionsTicimax1: "1. Ticimax yönetim panelinize giriş yapın",
            installationInstructionsTicimax2: "2. Tasarım > Tasarım ayarları > Header Footer Tasarımını açın",
            installationInstructionsTicimax3: "3. Logo tasarımı kısmında 'Kaynak'butonunu tıklayın.",
            installationInstructionsTicimax4: "4. HTML kodunun altına yukarıdaki entegrasyon kodunu yapıştırın.",
            installationInstructions: "Talimatlar",
            installationVerify: "Web Sitenizin Supsis Kurulumunu Doğrulayın",
            installationVerifyChecking: "Kontrol Ediliyor",
            installationVerifyCheck: "Kontrol Et",
            installationVerifyCheckingStatus: "{website} sitesinin SUPSIS entegrasyon durumu kontrol ediliyor",
            installationCheckingStatusMessageYes: "SUPSIS LIVE {website} sitesine entegre olmuştur.",
            installationCheckingStatusMessageNo: "SUPSIS {website} sitesine entegre değil !",

            vtippyPreferredLanguage: "Tercih Edilen Dil ",
        },
    },
    en: {

        volumeUp: "Volume Up",
        minimize: "Minimize",
        maximize: "Maximize",
        wp: {
            chatStarted: "Chat Started",
            chatNotStarted: "Chat Not Started",
            chatStartingWait: "Conversation starting, Please wait",
            whatsapp: "Whatsapp",
            agreement: "Agreement",
            purchase: "Purchase",
            activating: "Whatsapp Service Activation",
            authenticating: "QR Code Authentication",
            ready: "Ready",
            enableFeature: "Enable Whatsapp Feature",
            readAndAgree: "I have read and agree",
            subscribe: "Subscribe",
            subscribed: "Subscribed",
            toEnableWpDescription: "To enable Whatsapp Features , click on the button below.",
            waitForWpActivationDescription:
                "Your whatsapp account service is activating. Please wait for a while. It takes about 10-30seconds.",
            greatWpActivatedDescription: "Great, Your whatsapp account service is activated!",
            unsubscribe: "Unsubscribe",
            planDetails: "Integration Details",
            sendReceiveMessage: "Send & Receive Text Messages",
            sendReceiveImage: "Send & Receive Image Files",
            sendReceiveAudio: "Send & Receive Audio Files",
            sendReceiveGif: "Send & Receive GIF Files",
            startChat: "Start Chat on Supsis",
            supsisFunctionality: "Useful Supsis Chat Functionality",
            onePhoneMultiAgent: "One Phone and Multiple Agents",
            basicIntegration: "Basic Integration and Zero Configuration",
            activationTitle: "To activate whatsapp integration on supsis:",
            wpIntegrationInstruction1: "Open WhatsApp on your phone",
            wpIntegrationInstruction2: "Tap Menu or Setting. Click Linked Devices",
            wpIntegrationInstruction3: "Point your phone to this screen to capture the code",
            qrGeneratingWait: "QR Code Generating please wait...",
            pleaseContinueToWaitUntilCompleted:
                    "After the QR Code is verified, it will automatically switch to the completed field. Please wait...",
            authenticatingWait: "Authenticating, please wait...",
            unsubscribeWpInetgration: "Unsubscribe Whatsapp Integration",
            wpBack: "Back",
            terminatelWpInetgration: "When clicked the 'Unsubscribe' button, your whatsapp integration will terminate",
            cancelWpInetgration: "Do you want to cancel whatsapp integration?",
            startChatWp: "Start Chat",
            purchaseHeader: "Supsis-Whatsapp Integration Purchase",
            wpServices: "Whatsapp Service",
            wpServicesIntegrationCompleted: "Your whatsapp integration is completed. You can now use the service.",
            purchasePaymentDescription:
                "Whatsapp Feature billed month-to-month. Your whatsapp service will be activated after you accept subscription.",
            wpIntegrationFeatures:"Whatsapp Integration Features",
        },
        ticket: {
            ticketTagFilter: "Ticket Filter Tag",
            ticketEmails: "Ticket Forwarding Email List",
            save: "Save",
            delete: "Delete",
            transactions: "Options",
            noEmailTicketNotifications: "There is no data",
            emailIsNotValid: "Email is not valid",
            emailNotificationDeleted: "Item deleted successfully",
            emailNotificationDeleteError: "An error occurred",
            tagFilterRequired: "Ticket Filter Tag Required, Use *(wildcard) tag for all tickets",
            emailsRequired: "Forwarding Emails must not be null",
            emailNotificationCreated: "Ticket Forwading Rule Created",
            emailNotificationCreateError: "An error occurred",
            ticketForwarding: "Ticket Email Forwarding",
            ticketTagFilterDesc:
                "It uses the ticket topics you used in the chatbot design to filter the tickets. You can write a different tag and press enter to add it. If you select the '*' tag it will select all tickets",
            ticketEmailsDesc:
                "Email list to which tickets will be forwarded. You can add the addresses of the representatives in the system by selecting them. You can also add non-system email/s.",
            ticketList: "Ticket Forwarding Rules",
            ticketTagFilterPlaceHolder: "Ticket filter, select '*' for all",
            ticketEmailsPlaceHolder: "Forwarding email list",
        },
        theme: {
            opacity: "Opacity",
            headerColor1: "Hader Section Color 1",
            headerColor1A: "Hader Section Opacity 1",
            headerColor2: "Header Section Color 2",
            headerColor2A: "Header Section Opacity 2",
            backgroundColor: "Background Color 1",
            backgroundColorA: "Background Opacity 1",
            backgroundColor2: "Background Color 2",
            backgroundColor2A: "Background Opacity 2",
            textColor: "Text Color",
            errorTheme: "Error Color",
            bubbleBackground: "Chat bubble Background Color",
            bubbleBackgroundA: "Chat bubble Background Opacity",
            bubbleText: "Chat bubble text Color",
            selectCustom: "Select Custom Theme",
        },
        billing: {
            invoice: "Invoice",
            mustBeUpgradePlanForChatBot: "To activate the ChatBot feature, you must switch to the Pro Plan!",
            cardInfo: "Card Info",
            billingDetails: "Billing Details",
            addCardIyzico:
                "You do not have a registered card. In order to pay your monthly usage fees, you need to add a card. The payment system is provided by iyzico.",
            billingPlanSettings: "Billing & Invoice",
            startWith: "{cardFamily} card starts with {binNumber}",
            paymentMethod: "Payment Method",
            billingDate: "Billing Date",
            isPaid: "Is Paid?",
            paid: "Paid",
            markPaid: "Mark as Paid",
            paymentDate: "Payment Date",
            pay: "Pay",
            newInvoice: "Create Invoice",
            updateBilling: "Update Billing Detail",
            updateCard: "Change Credit Card",
            paymentBilling: "Payment Method & Billing Details",
            price: "Price",
            billingAddress: "Billing Address",
            billingCity: "City",
            billingCountry: "Country",
            contactName: "Billing Contact Name",
            expireMonth: "Expire Month",
            expireYear: "Expire Year",
            cardNumber: "Card Number",
            cardHolderName: "Card Holder Name",
            cardAlias: "Card Alias",
            identityNumber: "Identity Number",
            name: "Name",
            surname: "Surname",
            email: "Email",
            addCard: "Add Card",
            update: "Update",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving",
            noInvoiceFound: "There is no invoice",
            year: "Year",
            updating: "Updating...",
            newInvoiceForm: "New Invoice Create Form",
            error: "Error",
            transactions: "Options",
            paymentMethodAdded: "Payment method has successfully added",
            paymentMethodAddError: "Payment method has not added, An error occurred",
            creditCardChanged: "Credit card has successfully changed ",
            errorOccurred: "An error occurred , try again",
            billingDetailUpdated: "Billing detail has successfully updated",
            invoiceCreated: "Invoice has successfully created",
            paymentSuccess: "Payment successfully , thank you",
            paymentFail: "Payment fail, try again",
            billingAddressChanged: "Billing address has successfully changed ",
            hidePlan: "Hide Plan",
            informationShopping:
                "Your payment information, billing information, credit card information are controlled by Shopify.",
            trialTimeInformation:
                "Trial ends {dayCount} days after. If you do not enter a payment method until the expiry of this period, you will be automatically switched to the FREE PLAN by the system.",
            trialTimeInformationShort: "Trial: Last {dayCount} Day",
            currentPlanLabel: "Current Plan: {planName} ({agentCount} Agent)",
            changeCancelPlan: "Change/Cancel Plan",
            oneAgent: "Agent",
            agent: "Agent",
            yourCurrentPlan: "Current Plan",
            month: "Month",
            billedMonthToMonth: "(billed month-to-month)",
            selectAgentCount: "Select Agent Count",
            selectFreePlan: "Select Free Plan",
            planDetails: "Plan Details",
            multiAgent: "(Multi Agent)",
            selectProPlan: "Select Pro Plan",
            foreverFree: "Forever Free",
            websiteIntegration: "website integration",
            websiteIntegrationUnlimited: "website integration",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Video Call",
            multiAgentUpTo: "Multi Agent (up to {agentCount} Agent)",
            audioCallUnlimited: "Audio Call",
            screenSharingUnlimited: "Screen Sharing",
            fileTransferUnlimited: "File Transfer",
            autoChatAssignerUnlimited: "Auto Chat Assigner",
            multiLanguageTranslationUnlimited: "Auto Translate",
            detailedReporting: "Reporting",
            days30TrialsAvailable: "30-days trials available",
            limitedArchiveLookupLastMo: "Limited Archive Lookup (Last {monthCount}-mo)",
            fullCustomizationUnlimited: "Customization",
            planUpdated: "Great, your plan is updated.",
            planUpdating: "Your Plan is Updating...",
            planUpdatingDescription: "Please wait during your plan updating",
            done: "Done",
            freePlanUpdated: "Your plan updated as a Free Plan. (Max Agent Credit: 1)",
            proPlanUpdated: "Your plan updated as a PRO Plan. (Max Agent Credit: {agentCount})",
            canNotDwnGrade:
                "Cannot downgrade your plan from PRO {agentCountFirst} Agent(s) to {valNewPlnToUppr} {agentCountSecond}. Your agent credits in use.  ",
            deleteWarning: "You must delete or disable {valDif} Agent(s)",
            warnMessage: "Selected plan must be different than current plan",
            add: "Add",
            cancelYourPlan: "Cancel Your Plan",
            upgradeYourPlan: "Upgrade Your Plan",
            downgradeYourPlan: "Downgrade Your Plan",
            agree: "AGREE",
            disagree: "DISAGREE",
            invoices: "Invoices",
            priceIntervals: "Price Interval",
            selectSiteAlias: "Select or Enter Site Name",
            selectPriceInterval: "Select or Enter Price Interval",
            isRefunded: "Is Refunded?",
            invoiceId: "Invoice No",
            siteId: "Site No",
            createdDate: "Created Date",
            failCount: "Failed Payment Count",
            failDate: "Failed Payment Date",
            Dashboard: "Dashboard",
            Agents: "Agents",
            Integration: "Integration",
            Settings: "Settings",
            Contacts: "Contacts",
            Domain: "Domain",
            lastActivity: "Last Activity",
            basePrice: "Base Price",
            packagePrice: "Package Price",
            whatsappPrice: "Whatsapp Price",
            realtimeVisitorCount: "Real Time Visitor",
            suspend: "Suspend",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Trial Days",
            mobile: "Mobile",
            webSite: "Web Site",
            websiteOrigins: "Web Site Origin",
            ownerName: "Owner Name",
            ownerEmailAddress: "Owner Email",
            discount: "Discount",
            daysLeft: "Days Left",
            newTrialPopUp: "How Many Days Should the New Trial Period Be?",
            newWpPricePopUp: "How Much Is The New Whatsapp Fee?",
            newBasePricePopUp: "How Much Is The New Base Price?",
            siteInfoUpdated: "Site Information Updated",
            siteInfoNotUpdated: "Site Information Not Updated",
            siteInfoNotUpdatedErr: "Error Occured! Site Information Not Updated.",
        },
        chatbot: {
            link: "The bot, will send the link as a message",
            linkTitle: "Link Title",
            linkAddress: "Link Address",
            goto: "The bot returns to the step you specified",
            text: "The bot, will send given text as a message",
            randomText: "The bot, will randomly chose one of given texts and send selected text as a message.",
            image: "The bot, sends your uploaded image as a visual message.",
            ticket: "The bot, open a ticket for visitors to solved by represantatives later.",
            ticketTopic: "Ticket topic. Bot attack this topic when a ticket opened",
            ticketMessage: "After the bot opens a ticket, enter the message it will send to the user here",
            button: "Allows the bot to offer a choice to the visitors",
            question: "Allows the bot to ask questions to get information from the visitor",
            prev: "Allows the bot to return to the previous upper menu. ",
            closeChat: "The conversation is terminated after the messages here are sent by the bot.",
            transferLiveChatOption:
                "This option appears in the menu selection, the visitor can click and transfer the conversation to a live representative.",
            delay: "The messages are sent after waiting for a while with the typing indicator.",
            upload: "Click to upload image",
            imageView: "Click to view the image in large size",
            finishStep: "After this step, the chat will be closed automatically.",
            warnStep:
                "The bot will redirect to a live represantative, as you haven't added any more steps or turned off talk feature after this step.",
            deleteChatBotStepQuestion: "Are you sure delete this step?",
            chatbotStepWasDeleted: "Step was deleted",
            deleteMessageQuestion: "Are you sure delete this message",
            startToDesign: "START DESIGN",
            keywords: "KEYWORDS",
            typeKeyword: "Type Keyword",
            snDelay: "{delay} sec delay",
            welcome: "Welcome",
            untitled: "Untitled",
            untitledMenu: "Untitled Menu",
            menuMessage: "Menu Input Message",
            selection: "Selection",
            addNewButton: "Add new button",
            questionMessage: "Enter Your Question Message..",
            userName: "User Name",
            untitledForm: "Untitled Form",
            descriptionUserName: "Please enter your username",
            makeChoice: "Make Your Choice",
            subject: "Subject",
            menu: "Menu",
            contentTitle: "Content Title",
            subjectTitle: "Subject Title",
            buttonTitle: "Button Title",
            ticketSuccesfull: "Ticket Successfull",
            randomTextPlaceHolder: "Random Text",
            yes: "Yes",
            no: "No",
            questionLabel: "Enter Question Tag..",
            onlyImage: "You Can Only Upload Images!",
            imageSize: "Your Image's Size Should Be Maximum {size}!",
            types: {
                text: "TEXT",
                image: "IMAGE",
                ticket: "TICKET",
                random: "RANDOM",
                goto: "GO TO",
                link: "LINK",
            },
        },
        tour: {
            closeChat: "Close Chat",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Connect Representative",
            stats: "STATISTICS PANEL",
            settings: "SETTINGS",
            status: "STATUS",
            prevStep: "Previous Step",
            nextStep: "Next Step",
            finish: "Finish",
            skip: "Skip",
            skip2: "Skip, I know system",
            startTour: "Start Tour",
            firstTimeIntro:
                "You are entering the system for the first time, I want to introduce the application if you allow",
            hi: "Hi",
            welcomeTo: "Welcome to Supsis Live Support",
            statsPanel:
                "It is the status bar showing the total and active chat numbers that are waiting instantly with the system..",
            sidebarMenu: "MENU",
            sidebarMenuContent: "You can switch between pages here.",
            representativePrivateMessage: "INTER-REPRESENTATIVE CONVERSATION PANEL",
            representativePrivateMessageContent: "You can see private conversations between agents here.",
            helpMenu: "HELP MENU",
            helpMenuContent: "You can find help information about the system here..",
            settingsMenu: "SETTINGS MENU",
            settingsMenuContent: "You can do the language, night mode and screen magnification steps here..",
            startChat: "Start Chat",
            profileMenu: "PROFILE MENU",
            profileMenuContent: "You can change your availability and set your agent settings here..",
            visitorsTab: "Visitors",
            visitorsTabContent: "You can see visitors here.",
            visitorTabHistory: "Visitor History",
            visitorTabHistoryContent: "You can see the visitor history here.",
            representativeTab: "Representatives",
            representativeTabContent: "You can see the representatives here.",
            liveSupport: "Live support",
            liveSupportContent: "You can see the number of customers receiving Live Support here..",
            siteVisitors: "Site Visitors",
            siteVisitorsContent: "You can see the number of site visitors here.",
            tableSettings: "Table Settings",
            tableSettingsContent: "You can show or hide columns in the table here.",
            watchModeButton: "Viewer Button",
            watchModeContent: "You can join here as a viewer mode and you can only view what is posted.",
            popoverInfo: "Visitor Details",
            popoverInfoContent: "It gives information about the visitor.",
            popoverButton: "Advanced Chat Settings",
            popoverButtonContent:
                "You can open the conversation, send a message directly to the representative or block the visitor.",
            openChat: "Join Conversation Button",
            openChatContent: "You can open the conversation here",
            pagination: "Paging Menu.",
            paginationContent: "You can increase the number of pages here.",
            changeLang: "Can change system language",
            changeTheme: "Can switch dark and light theme",
            changeStatus: "Can change your availability status",
            logout: "Can logout system from here",
            chatwindow: {
                chatWindowActionButtons: "CHAT WINDOW ACTION BUTTONS",
                chatPanelActions: "CHAT PANEL ACTIONS",
                otherPanels: "OTHER PANELS",
                chatColorButton: "Show meaning of chat bar colors",
                keyboardShortcutButton: "Show keybpard shortcuts functions",
                hideButton: "Minimize current chat without exit",
                closeButton: "Force close and exit from current chat",
                ellipsisButton:
                    "More actions of chat. Minimize,close, Ban Visitor , Send Private Message , Assign Representative",
                userInfoWidget: "Show detail of owner visitor of current chat user",
                preparedContentWidget:
                    "Prepared Message Templates Widget, can select fastly insert a message template to current chat ",
                chatHistoryWidget: "If there are  some chat history of current visitor , can view them",
                chatWindowSettingsButtons: "TALK WINDOW SETTINGS BUTTON",
                settingsButton: "You can block conversation, forward, confidential message and assign delegates.",
                chatBarButton:
                    "Here you can block active conversation, send a private message to the agent and leave the conversation..",
            },
        },
        message: {
            chatLanguage: "Chat Language",
            translating: "Translating",
            buyWhatsapp: "Purchase WhatsApp integration",
            liveSupportStartingWait: "Starting Live Support, Please Wait",
            integrations: "Integrations",
            refundInvoiceSure: "Are you sure you want to return the invoice?",
            invoiceMarkedAsPaidSuccess: "Invoice has marked as paid successfully",
            invoiceMarkedAsPaidError: "Error, Invoice has not marked paid",
            deleteConfirm: "Do you want to delete this {object}?",
            markPaidConfirm: "Are you sure mark as paid this invoice?",
            addLink: "Link",
            startChatDesc: "Start Conversation",
            selectStep: "Select a step:",
            addGOTO: "Go to",
            sendFastLink: "Send Fast Link",
            or: "Or",
            allTags: "All Tags",
            showDetail: "Show Detail",
            hideDetail: "Hide Detail",
            weLlSendPhone: "We'll Send to Your Phone",
            weLlSendEmail: "We'll Send to Your e-Mail",
            linkSentToPhone: "Link sent as sms",
            offerlinkSendToPhone: "We will send you the download link of our application via SMS.",
            offerlinkSendToMail: "We will send you the download link of our application via e-mail.",
            theEmail: "My Registered Email",
            differentEmail: "Another Different Email",
            linkSentToMailBox: "Link was sent to your mail adress",
            errorOccurred: "Error occured !",
            clickStoreIcon: "You can access the mobile application by clicking the icon suitable for your phone.",
            meetWithSupsis: "Would you like to meet our SUPSIS mobile application?",
            downloadMobileApps: "Download Mobile App",
            getApps: "Get Apps",
            info: "Information",
            conversationHistory: "Conversation History",
            planInfoHeader: "Plan Information",
            planInformation: "Your plan is {selectedPlan} ({detailMaxAgentCount} Agent)",
            creditAvailable: "Your Agent credit available in your plan: ",
            upDownGradePlan: "If you want to upgrade/downgrade your plan, please",
            click: "Click",
            autoStartChat: "Automatic Chat Start",
            bubbleColor: "Chat Bubble Color",
            openFolder: "Open Folder",
            preDefined: "Themes",
            customIcon: "Install from your computer",
            theme: "Theme",
            themeSettings: "Theme Settings",
            bubbleSettings: "Chat Bubble Settings",
            bubbleIcon: "Chat Bubble Image",
            autoHideBubble: "Hide Chat Bubble",
            vtippyAutoHideBubble: "Hides chat bubble when agents are offline",
            deleteSite: "Do you want to Delete the site?",
            assetOversizeWithExt: "File size must be less than 10mb and in png,jpg format.",
            closeChat: "End Messaging",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Transfer to Representative",
            prevStep: "Return to Previous Step",
            addButton: "Button",
            addImage: "Image",
            addText: "Text",
            stepTitle: "Step Title",
            addTicket: "Ticket",
            formDescription: "Question",
            addInput: "Question",
            addRandomText: "Random Text",
            calendarPassedTimeMinSec: "{min} minute {sec} second {name}",
            calendarPassedTimeSec: "{hour} hour {min} minute {sec} second {name}",
            updateUserName: "Update Username",
            forgotPassword: "Forgot Password",
            osrFromMessageSaved: "Offline message saved.",
            requiredField: "This field is required.",
            nightModeOn: "Night Mode On",
            catalogMenu: "Menu",
            catalogContent: "Content",
            all: "All",
            allDepartments: "All Departments",
            preferredLanguage: "Preferred Language",
            kmkAutoDepartmentBind: "KMK Auto Deparment Find",
            kmkAutoDepartmentBindDesc: "Search Seller on KMK Customer Sites and set to login page as a department",
            visitorEmailUpdated: "Visitor email  updated",
            visitorEmailIsNotValid: "Visitor email is not valid",
            visitorNameUpdated: "Visitor name updated",
            clickToEdit: "Click to edit",
            addEmail: "+ Add Email",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Agent Count",
            closePreviewColors: "Close Theme Preview",
            previewColors: "Open Theme Preview",
            videoCalls: "Video Calls",
            filterLost: "Lost Chats",
            vtipyCustomLogin:
                "You can customize the information that will be requested in the login form when your visitors connect to the system.",
            vtipyLoginlessChat: "Visitor login form will be hidden. Visitor can connect to chat directly. ",
            loginlessChat: "Visitor Login Form Visible",
            imageUrl: "Image Url",
            openImage: "Open Image",
            writeFeedback: "You can write your feedback about Supsis here.",
            feedbackFailed: "An error occurred while sending feedback.",
            feedbackSuccessful: "Feedback submission successful.",
            sendFeedback: "Send Feedback",
            errorReport: "You can give us feedback about the problems you have about the SUPSIS.",
            sendErrorFeedBack: "Give us feedback on the issue you are experiencing.",
            successImgUpload: "Your image has been uploaded successfully.",
            errorImgUpload: "An error occurred while uploading your image.",
            chatBotEndStatics: "Chatbot Conversation Success Rate",
            videoCallDist: "Video Call Distribution",
            departmentInfo: "Department Info",
            infoAboutDepartment: "Give brief information about the department",
            deleteDepartmentQuestion: "Do you really want to delete this department?",
            departmentDeleted: "Department Deleted",
            departmentTitle: "Department Title",
            updateDepartmentForm: "Department Update Form",
            newDepartmentForm: "New Department Form",
            department: "Department",
            newDepartment: "New Department",
            departmentSaved: "Department Saved",
            departments: "Departments",
            chatTimingSettings: "Chat Timing Settings",
            assetOversize: "The size of the file you want to send should not exceed 2mb.",
            messageDeleted: "This message is deleted",
            filterLostChat: "Filter Lost Chats",
            filterVideoCall: "Video Call Filter",
            notificationText: "Supsis need permission to ",
            deniedText:
                "Your notifications are closed, you need to turn on your notifications so that you do not miss your customers.",
            showNotificationGuide: "Click for details",
            howToEnableNotification: "How Can I Enable Notifications",
            notificationOK: "Ok",
            notificationCancel: "Cancel",
            howToEnableNotificationInstruction1: "Click on the lock icon in the address bar of the browser",
            howToEnableNotificationInstruction2: "If 'Notifications' is disabled in the Permissions section, enable it",
            howToEnableNotificationInstruction3:
                'If "Notifications" does not appear in the Permissions section, click on "Site Settings"',
            howToEnableNotificationInstruction4:
                'Turn on the "Notifications" permission from the "Permissions" section of the site settings page',
            checkPaymentMethod: "Please check your payment method",
            pushNotificationEnabled: "Great, Push notification enabled",
            pushNotificationDenied: "You have denied the notification permission",
            suspendedMessage: "Your account has been suspended",
            enableNotification: "Enable Desktop Notifications.",
            languageSettings: "Selected Language",
            problemsSound:
                "If you have problems with notifications,You can click lock image from your browser search box (Shown in Picture) click 'Site Settings' and change 'Sound ' to Allow",
            betweenRepresentative: "There is a new message from a Representative",
            desktopNotifications: "Desktop Notifications",
            notificationEnabled: "Supsis desktop notifications is enabled.",
            newMessageAlert: "You have a new message.",
            notificationDisable: "You can disable notification from Representative settings",
            newConversationAlert: "You have a new visitor.",
            chatBot: "ChatBot",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "archive",
            chatbotChatCount: "CHATBOT",
            changeTitle: "Change Title",
            catalog: "Catalog Title",
            openTheCatalog: "Open Catalog",
            catalogNotOpen:
                "The catalog feature is disabled. You can turn on the catalog feature to support your customers with pre-prepared content.",
            showCatalogCategories: "Set whether catalog menu will show up on Chat bubble",
            showChatBot: "Set whether ChatBot will show up on Chat bubble",
            openCatalog: "Catalog Visibility",
            unreadMessages: "Unread Messages",
            personalFirstMsg: "Staff First Avg",
            personalRating: "Staff Score Avg",
            soundSettings: "Notification Settings",
            newPrivateMessage: "Private Message",
            newMessage: "New Message",
            newConversation: "New Chat",
            newVisitor: "New Visitor",
            chatPosition: "Chat Position",
            chatPositionSelect: "Choose Position",
            bottomLeft: "Bottom Left",
            left: "Left",
            bottomRight: "Bottom Right",
            right: "Right",
            mailorname: "E-Mail or Name",
            fieldName: "Key Name",
            value: "Value",
            addSetting: "Add a Settings",
            globalSettings: "Global Settings",
            breaksByTime: "Break count by time",
            clPlaceholder: "Name that will appear on the customer form",
            target: "Load Test Address",
            duration: "Load Test Duration(sec)",
            arrivalCount: "Chat Count",
            bootMaxLife: "Chat Max Life Time(sec)",
            startLoadTest: "Start Load Test",
            noClusterInstanceFound: "There is no server",
            stopLoadTest: "Stop Load Test",
            integrationDesc: "Just add the one-line code below to your site.",
            integrationDemoCode: "Simple integration demo code",
            integrationWindow: "How Do I Integrate To My Site ?",
            notIntegrated: "Integration",
            help: "Help",
            notIntegratedDesc:
                "We noticed that you did not add the chat system to your site. When you integrate it into your site and start the first chat, you will complete the integration. Click for INTEGRATION SCRIPT",
            backToLogin: "Go Back To Login Screen",
            passwordlessLoginUnsuccessful: "Login is not successful.Url could be expired or used before",
            passwordlessLogin: "Login Without Password",
            loginWithEmail: "Login With Email",
            loginWithPassword: "Login With Password",
            enteringPasswordless: "Login Without Password...",
            toMainPath: "Redirect to Main Page",
            userRoleChanged: "Your permissions changed. You will be redirected to main page.",
            passwordChangeSuccess: "Your Password Changed Successfully  ",
            feedback: "Show Feedback",
            showFeedbackHistory: "Show messages that have been sent feedback",
            newSelfServiceSite: "New Self Service Site",
            subdomain: "Subdomain",
            rootUserEmail: "Email",
            rootUserName: "Name",
            newVersion: "New Version Available",
            newVersionShort: "New Version",
            bannedWordRestrict: "Banned Word Blocking",
            autoLoadIframe: "Live Traffic",
            autoLoadIframeDesc: "Auto Load Iframe , Pass All Visitor Traffic",
            bannedWordRestrictDesc:
                "When the Forbidden Word Blocking is turned on, representatives are prevented from typing the prohibited words defined in the system to the visitors.",
            agentDown: "Agent Down",
            delayChat: "Delayed Chat",
            tableSettingTippy: "You can change the information that will appear in the table.",
            tableSettings: "Table Settings",
            tableSettingsInfo:
                "You can change the information that will appear in the table. You can select 7 column at most",
            cityAndDistrict: "City/District",
            general: "General",
            home: "Home",
            successful: "Succesfull",
            forgetPasswordSent: "Reset password link email was sent , check your inbox",
            saturday: "Saturday",
            friday: "Friday",
            thursday: "Thursday",
            wednesday: "Wednesday",
            tuesday: "Tuesday",
            monday: "Monday",
            sunday: "Sunday",
            download: "Download File",
            calendarPassedTimeHour: "{name} for {hour} hour",
            calendarPassedTime: "{name} for {hour} hour {min} min",
            calendarPassedTimeMin: "{name} for {value} min",
            workScheduleOneDay: "{name}'s working schedule on {sDate}",
            workSchedule: "{name}'s working schedule between {sDate} - {eDate}",
            calendar: "Calendar",
            noRating: "There is no Rating to Show",
            rateDist: "Distribution of  Rates",
            distConversation: "Distribution of Conversations",
            totalWhatsappChatCount: "Whatsapp Chat Count",
            statsByTime: "Number of Chat by Time",
            selectRep: "Select a representative",
            allRepresentatives: "All Representatives",
            avgRating: "Rating Score({point}) ({count} Rating) ",
            avgFirstMessageTime: "Average Response Time",
            totalBreakTime: "Break Time",
            totalBreakNum: "Break Count",
            averageConTime: "Average Conversation Time",
            longestConTime: "Longest Conversation Time",
            shortestConTime: "Shortest Conversation Time",
            refresh: "Refresh",
            waitingReply: "Pending Messages",
            organizationName: "Organization Name",
            messageSentErr: "Message not send, Try again.",
            messageSent: "Message Sent.",
            openPrivateChat: "Open Representative Chat",
            escKey: "Hides active conversation",
            privateChat: "Inter-Agents Conversation Panel",
            multiModeAlertDesc: 'SUPSIS is open in another window. Click "Use Here" to use SUPSIS in this window.',
            useHereText: "Use Here",
            brandVisibility: "SUPSIS brand label show up on chat bubble",
            focusInput: "Focus cursor active chat's input field ",
            send: "Send",
            notYet: "Not yet",
            sending: "Sending",
            onlyRepresentative: "Your message can seen only by representatives",
            yourMessage: "Your message",
            notValid: "You can only enter letters. (Single character).e,d,f,z,a,x,c,v,w,t,n letters are invalid",
            forMacUsers: " Mac users can use  Control(⌃) shortcut",
            basePriceValue: "Base Price",
            basePriceDiscount: "Discount",
            basePriceCurrency: "Currency",
            customerDBEnabled: "Database Selection: Use Customer Database Server",
            customerDBDisabled: "Database Selection:  Use Supsis Database Server",
            mongoConnectionString: "Mongo Connection",
            whatsappBasePriceValue:"Whatsapp Base Price",
            clientAddress: "Client Address",
            customerClientAddress: "Customer Client Address",
            apiAddress: "Api Address",
            socketAddress: "Socket Address",
            backendAddress: "backend Address",
            panelLogoUrl: "Panel Logo Url",
            panelCustomCssUrl: "Panel Custom Css Url",
            customerLogoUrl: "Customer Logo Url",
            customerCssUrl: "Customer Css Url",
            siteAlias: "Site Alias",
            language: "Language",
            features: "Features",
            represantativeSettings: "Represantative Settings",
            chatBalloonTehemeSettings: "Chat Balloon & Theme Settings",
            customLoginFormSettingsTitle: "Customize Visitor Login Form",
            addNewField: "Add New Field",
            editField: "Edit Field",
            typeHere: "Type the content here!",
            pco: "CUR",
            perPage: "/page",
            startFilter: "Start filter",
            showMyChats: "Show My Chats",
            showOnlineAgents: "Show Only Online Agents",
            showWaitingChats: "Show Waiting Chats",
            newTitleContent: "New Title",
            newCTRLContent: "New CTRL Content",
            newALTContent: "New ALT Content",
            newTABContent: "New TAB Content",
            roleName: "Role Name",
            error: "Error",
            contentTitle: "Content Title",
            contentType: "Content Type",
            cannotMoveFullParent: "Cannot move this item",
            newSiteForm: "New Site Register Form",
            updateSiteForm: "Site Update Form",
            newBannedWordForm: "New Banned Word Register Form",
            updateBannedWordForm: "Banned Word Update Form",
            newWelcomeMessageForm: "New Welcome Message Register Form",
            updateWelcomeMessageForm: "Welcome Message Update Form",
            newDefaultContentForm: "New Default Content Register Form",
            updateDefaultContentForm: "Default Content Update Form",
            newSubjectForm: "New Subject Register Form",
            updateSubjectForm: "Subject Update Form",
            showChatColorMeaning: "Chat Colors",
            showIntro: "Show Intro",
            options: "Options",
            resetPassword: "Reset Password",
            audioLevel: "Volume of audio alert",
            privateChatNotificationSound: "Notification sound",
            continue: "Continue",
            newRoleForm: "New Role Register Form",
            updateRoleForm: "Role Update Form",
            newRolePlaceHolder: "Click to new role",
            newUserForm: "New User Register Form",
            updateUserForm: "User Update Form",
            changeOSRForm: "Offline Change Message",
            tooltipOSRForm: "You can change the offline message.",
            newOSRForm: "Offline Support Form",
            newOSRMessages: "Add Offline Message",
            updateOSRForm: "Offline Update Form",
            osrTitle: "Title",
            osrTitleDescription: "You can add offline support form title",
            osrContent: "Content",
            osrContentDescription: "You can add offline support form content",
            hello: "hello world",
            date: "Date",
            startDate: "Start Date",
            finish: "Finish",
            start: "Start",
            search: "Search",
            endDate: "End Date",
            representative: "Representatives",
            representative_: "Representative",
            star: "Star",
            filter: "FILTER",
            reset: "RESET",
            dailyChatList: "Daily Chat List",
            dailyChatDuration: "Daily Chat Duration",
            chatDuration: "Chat Duration",
            dailyChatGraph: "daily Chat Graph",
            ok: "OK",
            cancel: "Cancel",
            chatCount: "Chat Count",
            shortest: "Shortest",
            longest: "Longest",
            average: "Average",
            count: "Count",
            averagePoint: "Average Point",
            pointDist: "Point Distribution",
            point: "Point",
            filters: "Filters",
            totalCustomer: "Total Customer",
            avResponseTime: "Average Reponse Time",
            breakDuration: "Break Duration",
            breakCount: "Break Count",
            lastLoginPlatform: "Platform",
            active: "Active",
            passive: "Passive",
            userForm: "User Form",
            profile: "Profile",
            name: "Name",
            number: "Number",
            username: "User name",
            email: "Email",
            password: "Password",
            oldPassword: "Old Password",
            newPassword: "New Password",
            passwordAtLeast: "Password (at least {num} character)",
            passwordRepeat: "Repeat Password",
            changePassword: "Change Password",
            status: "Status",
            enableState: "Active?",
            douYouWishToDeleteUser: "Dou you wish to delete this user?",
            userDeleted: "User Deleted",
            userSaved: "User saved.",
            oldPasswordError: "The old password is incorrect, please check.",
            userVolumeUpdated: "Volume settings updated.",
            save: "Save",
            update: "Update",
            addNewMenu: "Add New Menu",
            addNewContent: "Add New Content",
            pleaseTitleEnter: "Please title enter",
            like: "Like",
            disLike: "Dislike",
            users: "Users",
            allContacts: "All Contacts",
            allUsers: "All Representatives",
            allSites: "All Domains",
            newUser: "New User",
            noNewUser: "There is no user yet.",
            noNewAdminUser: "There is no admin user yet.",
            noRoleFound: "There is no role yet.",
            noBannedWordFound: "There is no banned word yet.",
            noWelcomeMessageFound: "There is no welcome message yet.",
            noSubjectFound: "There is no subject yet.",
            noVisitorFound: "There is no visitor.",
            noContactFound: "There is no contact.",
            sendResponse: "Write a Response",
            delete: "Delete",
            noLiveSupportFound: "There is no visitor connect to live support",
            noRePresentativeFound: "There is no representative",
            noBannedVisitorFound: "There is no banned visitor yet.",
            removeBanDescription: "Remove ban",
            editThisItem: "Update this item",
            removeThisItem: "Remove this item",
            role: "Role",
            autoChatAssignLimit: "Auto Chat Assign Limit",
            chatAssignInfo: "-1 = System Default, 0 = No Assign, >0 = Assign as given value.",
            relatedDepartments: "Related Departments",
            subjectInfo: "If there is no selected subject, all subjects are allowed.",
            archive: "Archive",
            offlineSupportRequests: "Offline Supports",
            first: "First",
            last: "Last",
            query: "Start Searching",
            clean: "Clean",
            loading: "Loading",
            loadMore: "Load More",
            noMessage: "Is not any message",
            selectChat: "Pick a Chat",
            noMessageInChat: "There is no message in this chat",
            userInfo: "User Info",
            chatId: "Chat ID",
            visitingPage: "Visiting Page",
            osAndBrowser: "Operating System & Browser",
            customerClientVersion: "Customer Client Version",
            visitorFeedback: "Visitor Feedback",
            nameSurname: "Name & Surname",
            chats: "Chats",
            bannedVisitors: "Banned Visitors",
            country: "Country",
            city: "City",
            cityDistrict: "City District",
            browser: "Browser",
            os: "Operating System",
            ipAddress: "IP Address",
            connectionDate: "Connection Date",
            transaction: "Transaction",
            banRemoved: "Ban Removed.",
            bannedWords: "Banned Words",
            newBannedWord: "New Banned Word",
            noBannedWord: "No banned word yet.",
            bannedWordForm: "Banned Work Form",
            word: "Word",
            bannedWordAndWordGroup: "Banned word / work group",
            doYouWishToDeleteBannedWord: "Dou you really wish to delete this banned word?",
            doYouWishToOfflineSupportRequest: "Dou you really wish to delete this message?",
            bannedWordSaved: "Banned word saved",
            deletedSuccessfully: "Deleted Successfully",
            deleteErrorMsg: "Error: It's not deleted, try again",
            socketError: "Socket connection error. Please refresh page and try again.",
            socketConnecting: "Connecting to server",
            offlineModeDescription: "System down, customers will not be able to access live support.",
            offlineModeSettingsDescription: "Check the Offline Mode feature in the settings menu.",
            offlineModeUser: "There must be at least one online representative in the system.",
            offlineModeMessage: "Offline Message",
            offlineMode: "Offline Mode",
            adminCannotConnectSocket: "Admin cannot connect to socket.",
            liveSupport: "Live Support",
            siteVisitors: "Site Visitors",
            visitors: "Visitors",
            thoseConnectedToLiveSupport: "Those who connected to live support",
            visitorHistory: "Visitor History",
            privateMessage: "Private Message",
            addRepresentative: "Add Representative",
            forwardRepresentative: "Forward Representative",
            keyboardShortcuts: "Keyboard Shortcuts",
            chatColorMeanings: "Chat color meanings",
            connLostCheckInternet: "Connection lost, please check your internet connection.",
            wishToEndThisChat: "Dou you wish to end this chat?",
            defaultContents: "Default Contents",
            newDefaultContent: "New Default Content",
            title: "Title",
            shortcutChar: "Shortcut Character",
            pickOne: "Pick one",
            writeSomething: "Write a character (a-z|0-9)",
            letterSequence: "Letter Sequence",
            exampleText: "Example: soc -> soccer",
            anyChar: "Any character",
            shorcutKey: "Shortcut Key",
            content: "Content",
            shortcutName: "Shortcut Name",
            type: "Type",
            shortcut: "Shortcut",
            defaultContentForm: "Default Content Form",
            deleteContentQuestion: "Do you really wish delete this default content?",
            defaultContentDeleted: "Default content deleted",
            defaultContentSaved: "Default content saved.",
            contentMoved: "Content Moved.",
            yourEmail: "Email Address",
            yourName: "Your name",
            login: "Login",
            lostPassword: "Forgot Password",
            multipleSession: "You are signed in elsewhere.",
            notAuthorizedToDisplayPage: "You are not authorized to see this page!",
            permissions: "Permissions",
            newPermission: "New Permission",
            permissionForm: "Permission Form",
            displayTitle: "Display Title",
            key: "Key",
            keyToUseInSystem: "Key value to use in the system",
            deletePermissionQuestion: "Do you really wish to delete this permission?",
            permissionDeleted: "Permission deleted.",
            permissionSaved: "Permission Saved.",
            newRole: "New Role",
            selectARole: "Select a Role",
            yes: "Yes",
            no: "No",
            fullAuth: "Full Authorization",
            roleDeleted: "Role deleted.",
            roleSaved: "Role saved.",
            roleForm: "Role Form",
            roles: "Roles",
            settings: "Settings",
            selectTopic: "Select Department",
            autoCallTransfer: "Auto Call Transfer",
            customerTyping: "Customer typing",
            typing: "Typing",
            agentTyping: "Representative typing",
            disconnectTime: "Max Reconnection Time (sec)",
            tippyDissconnectTime: "When a chat inactive after how many seconds conversation will end.",
            queueNumberVisibleFeature: "Show Queue Number to Visitor",
            privateChatEnabled: "Show The Chat Between Representatives",
            delayedTalkTime: "Delay Time (sec)",
            employeeAverageChatCount: "Average chat number for employee chat rate",
            customerDownTimeWhenRepExit: "Customer downtime when representative leaves (sn.)",
            autoAssignLimit: "Auto Assign Limit",
            wasted: "Conversation Lost Time (sec)",
            settingFormWrong: "Form data is wrong, try again after check it",
            settingsSaved: "Settings saved.",
            delayTime: "Delay Time (sec)",
            sites: "Sites",
            newSite: "New Site",
            noSiteYet: "There is no site yet.",
            siteAddress: "Site Address",
            customerRepLimit: "Customer Representative Limit",
            siteSaved: "Site saved.",
            siteSaveError: "An error occured during creating site",
            subjects: "Subjects",
            newSubject: "New Subject",
            noSubject: "No subject yet.",
            subject: "Subject",
            subjectTitle: "Subject Title",
            description: "Description",
            infoAboutSubject: "Information about subject",
            deleteSubjectQuestion: "Do you really wish to delete this subject?",
            subjectDeleted: "Subject deleted.",
            subjectSaved: "Subject saved.",
            welcomeMessages: "Welcome Messages",
            newWelcomeMessages: "New Welcome Message",
            noWelcomeMessage: "No Welcome Message.",
            welcomeMessageContent: "Welcome message content",
            makeChoice: "Make a choice...",
            welcomeMessage: "Welcome Message",
            repLoggedIn: "Representative logged in",
            loginMessage: "Log in message",
            message: "Message",
            deleteWelcomeMessageQuestion: "Do you really wish to delete this welcome message?",
            welcomeMessageDeleted: "Welcome message deleted",
            welcomeMessageSaved: "Welcome message saved.",
            welcomeMessageForm: "Welcome Message Form",
            noRep: "There is no representative yet.",
            addChat: "Add Chat",
            forwardChat: "Forward Chat",
            ago: "ago",
            repName: "Representative Name",
            lastOnline: "Last Connection/Online time",
            lastStatusChange: "Last Status Change",
            activeChat: "Active Chat",
            userMaxCapacity: "Max Chat Capacity",
            noActiveChat: "No active chat",
            watch: "WATCH",
            join: "JOIN",
            open: "OPEN CONVERSATION",
            directMessage: "PRIVATE MESSAGE",
            block: "BLOCK",
            transactions: "Transactions",
            informations: "Informations",
            visitStart: "Visit Start",
            fullName: "Fullname",
            waitChatTime: "Waiting/Chatting Time",
            blockUserConfirm: "Do you want to block this user?",
            messaging: "Messaging",
            hideChat: "Hide Chat",
            block_: "Block",
            privateMessage_: "Private Message",
            assignRep: "Assign Representative",
            joinChat: "Join Chat",
            forwardRep: "Forward",
            leaveChat: "Leave Chat",
            endChat: "End Chat",
            translatedTextDescription: "Amazon translated this message {from} -> {to}.",
            autoTranslate: "Auto Translate",
            translateThisMessage: "Translate this message",
            autoTranslateDetectedDesc:
                "Visitor language is {visitorLanguage}. Click Here to Activate Automatic Translation",
            on: "on",
            off: "off",
            copy: "Copy",
            prevChats: "Previous Chats",
            noShortCut: "No shortcut",
            leaveChartConfirm: "Dou you really wish to leave the chat?",
            endChatConfirm: "Dou you wish to end the chat?",
            endConversation: "End Conversation",
            onlyOneRep: "You are the only representative in this conversation!",
            chatList: "Chat List",
            chatBar: "Chat Bar",
            unreadTitle: "Unread",
            visitorLeftTitle: "Visitor Left",
            activeChatTitle: "Active Chat",
            autoAssignedTitle: "Auto Assigned Chat",
            watchModeTitle: "Watch Mode",
            lostChat: "Representative Connection Lost",
            chatWidthDelay: "Chat with Delay",
            repChatWidthDelay:
                "When there is no active representative in the system or all of our representatives full due to high traffic, chat background will be green  ",
            repLostConn: "If customer representative has lost connection, chat background will be pink.",
            unreadMsg: "If there are unread messages, the background will be light blue.",
            visitorLeftChat: "If the visitor left the conversation, the background becomes dark gray.",
            activeChatMsg: "Background is green if chat is active",
            autoAssignMsg:
                "The background becomes mustard if assigned by automatic assignment and the conversation is not looked further",
            watchModeMsg: "If turned on in playback mode, the background becomes red",
            online: "Online",
            beRightBack: "Away",
            away: "Away",
            busy: "Busy",
            offline: "Offline",
            logout: "Log out",
            forWindows: "For Windows",
            forMac: "For Mac",
            nextChatFromActive: "Switch from active to next conversation",
            previousChatFromActive: "Switch from active to previous",
            hideActiveChat: "Hide active conversation",
            closeActiveChat: "Close active conversation",
            firsthiddenChat: "Join most waited customer's chat",
            firstChatWaiting: "Switch to waiting conversation",
            previousOpenedChat: "Regardless of the order, skip to the previously opened conversation",
            historyDetails: "History Details",
            chat: "Chat",
            chatNotFound: "Chat Not Found.",
            visitorInfo: "Visitor Info",
            timeSpent: "TimeSpent",
            noActiveVisitors: "No active visitors",
            totalConnected: "Conversation Count",
            missedChat: "Missed Chat Count",
            workTime: "Work Time",
            closedChatCount: "Closed Chat",
            activeConvo: "Active conversation",
            notAnswered: "Not yet answered",
            delayedConvo: "Delayed",
            leavingRep: "Leaving representative",
            staffRate: "Staff Working Rate",
            select: "Dropdown Menu",
            fullname: "Full Name",
            text: "Text",
            numeric: "Number",
            phone: "Phone",
            optionsPlaceholder: "Option value",
            selectField: "Click if you want to add a dropdown menu",
            fullnameField: "Click if you want to add a full name field.",
            textField: "Click if you want to add a text field.",
            numericField: "Click if you want to add a numeric field.",
            phoneField: "Click if you want to add a phone field.",
            departmentField: "Click if you want to add a department field.",
            emailField: "Click if you want to add a email field.",
            visible: "Visible",
            required: "Required",
            label: "Comment",
            customLoginAlert: "Your Login Form must contain least one  visible field.",
            atLeastOneLanguage: "You must feel at least one language",
            requiredFieldField: "This field is required",
            notRequiredField: "This field is not required",
            visibleField: "This field is visible",
            notVisibleField: "This field does not appear in the form.",
            connectServer: "You are connected to the server",
            disconnectServer: "You are not connected to the server",
            liveChatOff: "Live chat is off",
            visitorScreen: "Visitor Screen",
            showHint: "Show Hint",
            dontShowHint: "Don't Show Hint",
            liveChatOn: "Live chat is on",
            nightModeOff: "Night mode off",
            doubleClickEdit: "Double click or press the edit button to edit.",
            edit: "Edit",
            deleteField: "Delete",
            arrow_upward: "Arrow Upward",
            arrow_downward: "Arrow Downward",
            newCatalogCategory: "New Catalog Category",
            childCreate: "Double click to create a new child",
            updateCatalogCategoryFrom: "Update Catalog Category Form",
            newCatalogCategoryFrom: "New Catalog Category Form",
            catalogCategoryMenu: "Add catalog category menu",
            catalogCategoryLeaf: "Add catalog category submenu",
            catalogCategoryName: "Catalog category name",
            newCatalogContentFrom: "New Catalog Content Form",
            catalogContentName: "Catalog content name",
            catalogCategorySaved: "Catalog category saved",
            catalogCategoryDeleted: "Catalog category deleted",
            catalogCategoryRate: "Content Rate",
            catalogContentFeature: "Catalog Content feature",
            vtipyAudioLevel: "Used to mute or unmute notification sounds.",
            vtipyOrganizationName: "You can change the organization name and update it.",
            vtipyBrandVisibility: "Supsis is the setting whether the tag can be displayed in the chat bubble.",
            vtipyBrandVisibilityForced: "Only ProPlan users can change!!",
            vtipyClientDefault: "You can change the agent page language here.",
            vtipyCustomerClientDefault: "You can change the language of the customer (Chat) page here.",
            vtipyVisitorPreferredLang: "The customer can select the spoken language on the (Chat) page.",
            vtipyCustomerClientLanguageDetect: "You can change the language of the customer (Chat) page here.",
            vtipySelectTopic: "Automatic assignments to existing representatives in the selected department occur.",
            vtipyAutoCallTransfer: "Automatically assigns waiting calls to available agents.",
            vtipyCustomerTyping:
                "It allows you to see what the customer wrote on the chat screen on the representative chat screen.",
            vtipyAgentTyping: "It give information when representative typing to customer in chat buble",
            vtipyQueueNumberVisibleFeature:
                "When representatives are busy, it shows customers who want to connect, in what order they are.",
            vtipyPrivateChatEnabled: "Shows the inter-agent conversation panel.",
            vtipyDelayedTalkTime:
                'If no delegates are connected to the conversation during this time, it will be labeled \\ "Delayed Chat \\',
            vtipyOfflineMode: "Allows you to put the system in offline mode.",
            vtipyAutoAssignLimit:
                "It determines how many customers (chat) will be assigned to the representative automatically.",
            vtipyCustomerDownTimeWhenRepExit: "Customer idle time when the representative exits (sec.)",
            tippyDisconnectTime: "The chat close time after disconnect the customer (sec).",
            changeSettings: "Change Global Settings",
            totalBg: "TOTAL",
            activeBg: "ACTIVE",
            watchBg: "WATCH",
            waitingBg: "WAITING",
            lateBg: "LATE",
            freeBg: "FREE",
            maxCapacityBg: "MAX CAPACITY",
            addNewSettings: "Add a New Global Settings",
            darkMode: "Dark Mode",

            clientDefault: "Panel default language",
            customerClientDefault: "Customer client default language",
            customerClientLanguageDetect: "Customer Client Language Auto Detect",
            visitorPreferredLang: "Let the customer choose the spoken language",
            preferredThemeColor: "Preferred Theme Color For Client Chat Screen",
            detail: "Detail",
            supportUs: "Contact Us (Live Support)",
            langSetting: "Language Setting",
            changeLang: "Change Language",
            fontSizeSetting: "Screen Zoom Setting",
            changeLangDesc: "Changes application language to {code}",
            trLang: "Turkish",
            enLang: "English",
            fieldRequired: "{field} field is required",
            selectALanguage: "Select A Language",
            selectATheme: "Select A Theme",
            responseForm: "Response Form",
            clientRequestInfo: "Client Request Info",
            createdDate: "Created Date",
            descMessage: "Messages",
            new: "New",

            selectAllPermission: "Select All",
            catalogCategories: "Catalog",
            copiedClipboard: "Copied to clipboard",
        },
        adminUser: {
            newAdminUserForm: "New Admin User Register Form",
            updateAdminUserForm: "Admin User Update Form",
            adminUsers: "Admin Users",
            newAdminUser: "New Admin User",
            noAdminUser: "No Admin Users Yet",
            adminUserName: "Admin User Name",
        },
        report: {
            detailReport: "Detailed Report",
            dailyReports: "Daily Reports",
            pointBasedReports: "Point Based Reports",
            personDateBasedPointReport: "Person and Date Based Point Report",
            personDateBasedReport: "Person and Date Based Report",
            personBasedReport: "Person Based Reports",
            personAndDateBasedGraph: "Person and Date Based Graph",
            noReport: "No Report",
            reports: "Reports",
            totalBar: "Total",
        },
        stats: {
            total: "Number of  all  open chats",
            active: "Number of   assigned active chats to you",
            waiting: "Number of visitors waiting for a representative to enter",
            late: "Number of visitors waiting more than a certain period",
            free: "Number of free visitors waiting for the new representative to enter",
            pco: "[Capacity Utilization Rate] Rate of work load of active representative chat capacity",
            maxCapacity: "Maximum number of chat that the system can assign representatives without waiting",
            chatbot: `Number of active chat with chatbot`,
        },
        time: {
            today: "Today",
            yesterday: "Yesterday",
            lastWeek: "Last Week",
            currentWeek: "This Week",
            currentMonth: "This Month",
            lastMonth: "Last Month",
            last30Day: "Last 30-day",
            allTime: "All Times",
            custom: "Custom Date",
        },
        fastWizard: {
            tellUsMore: "Tell us more , so we can personalize your experience",
            moreInfo: "More Info",
            display: "Display",
            availability: "Availability",
            preview: "Preview",
            installCode: "Install Code",
            previous: "Previous",
            setupSupsisLiveChat: "Setup SUPSIS LIVE Chat ",
            continue: "Next Step",
            completeInitialize: "Complete Setup",
            completedMessage: "SUPSIS Live Chat Setup Successfully  Completed.",

            websiteIntegration: "Your website address to integrate supsis live chat",

            customizeLiveChat: "Customize Your Live Chat",
            createBrandedExperience: "Create a branded chat experience for your visitors.",
            chatColor: "Chat Color",
            chooseChatColor: "Choose an accent color.",
            chatBubble: "Chat Bubble",
            selectBubble: "Select a chat bubble",
            chatBubbleColor: "Chat Bubble Color",
            selectChatBubbleColor: "Select a chat bubble color",
            customSelection: "Custom Selection:",

            chatAvailability: "Chat Availability",
            onlineSupportVisitorTime: "When are you online to support your visitors?",
            channelAvailability: "Channel Availability",
            availability724: "Chat is available 7/24",
            basedOnTeam: "Based on Team Member Status",
            basedOnTeamExplanation: "Chat will appear online when at least 1 member is set to available",
            customHours: "Custom Business Hours",
            customHoursExplanation: "Configure your business hours",
            customHoursTimezone: "Timezone:",
            customHoursFrom: "From:",
            customHoursTo: "To:",
            customHoursAddHours: "+Add Hours",

            previewDesktop: "Desktop",
            previewIpad: "Ipad",

            installationAndInstructions: "Installation & Instructions",
            installationTrackingCode: "Install the tracking code on your website",

            installationTrackingCodePlease:
                "Please paste the code in accordance with the instructions below, just before the end of the {bodyTag} tag on any page where you want to enable SUPSIS Live chat.",
            installationInstructionsJavascript:
                " Paste the integration code given above in the {bodyTag} tag just before the closing.",
            installationInstructionsCopy: "Copy",
            installationInstructionsCoppyMessage: "Integration script copied to clipboard",
            installationInstructionsShopify1: "1. Login to your Shopify panel",
            installationInstructionsShopify2:
                "2. Go to Online Store > Themes > Actions drop-down menu under Current Theme > Edit code > theme.liquid",
            installationInstructionsShopify3:
                "3. Place paste the integration code given above just before the  {bodyTag}  tag at the end of the theme.liquid script.",
            installationInstructionsIdeaSoft1: "1. Login to your dealer panel.",
            installationInstructionsIdeaSoft2: "2. Go to Settings -> SEO -> Search Engine Services.",
            installationInstructionsIdeaSoft3:
                '3. Select "Site Verification with Meta Tag" from the Tracking Code section.',
            installationInstructionsIdeaSoft4:
                "4. Copy and paste the integration code above into the opened box and save.",
            installationInstructionsIdeaSoft5:
                '5. Inside Settings -> Optimizations click to "Clear Cache" button. Thus integration is completed.',
            installationInstructionsWordPress1: "1. Login to your WordPress admin panel",
            installationInstructionsWordPress2: "2. Go to Appearance > Theme Editor",
            installationInstructionsWordPress3:
                "3. Under Theme Files (far right), find the Theme Footer (footer.php) and select it",
            installationInstructionsWordPress4:
                "4.Paste the integration code above before the {bodyTag} tag at the bottom.",
            installationInstructionsWordPress5: "5. Click Update File to save changes",
            installationInstructionsOpenCart1: "1. Login to your Opencart admin panel",
            installationInstructionsOpenCart2: "2. Go to Design > Theme Editor",
            installationInstructionsOpenCart3: "3. Select 'common' folder and open 'header.twig' file.",
            installationInstructionsOpenCart4:
                "4.Paste the integration code above before the {headTag} tag at the bottom.",
            installationInstructionsOpenCart5: "5. Click save button.",
            installationInstructionsTicimax1: "1. Login to your Ticimax administration panel",
            installationInstructionsTicimax2: "2. Open Design > Design > Header Footer Design settings",
            installationInstructionsTicimax3: "3. Click the 'Source' button in the logo design section.",
            installationInstructionsTicimax4: "4. Paste the integration code above below the HTML code.",
            installationInstructions: "Instructions",
            installationVerify: "Verify Your Website Installation of Supsis",
            installationVerifyChecking: "Checking",
            installationVerifyCheck: "Check",
            installationVerifyCheckingStatus: "Checking SUPSIS integration status on {website}",
            installationCheckingStatusMessageYes: "Great, SUPSIS is integrated to {website} website !!",
            installationCheckingStatusMessageNo: "SUPSIS is not integrated on {website} !",

            vtippyPreferredLanguage: "Preferred Language",
        },
    },
    ru: {
        volumeUp: "Volume Up",
        minimize: "Minimize",
        maximize: "Maximize",
        wp: {
            whatsapp: "Whatsapp",
            chatStarted: "Чат начался",
            chatNotStarted: "Чат не запущен",
            chatStartingWait: "Разговор начинается, пожалуйста, подождите",
            agreement: "Соглашение",
            purchase: "Покупка",
            activating: "Активация сервиса WhatsApp",
            authenticating: "Аутентификация по QR-коду",
            ready: "Готовый",
            activationTitle: "Чтобы активировать интеграцию с WhatsApp на Supsis:",
            wpIntegrationInstruction1: "Откройте WhatsApp на своём телефоне",
            wpIntegrationInstruction2: "Нажмите «Меню» или «Настройки». Щелкните Связанные устройства.",
            wpIntegrationInstruction3: "Наведите свой телефон на этот экран, чтобы считать код",
            qrGeneratingWait: "Генерируется QR-код, пожалуйста, подождите...",
            pleaseContinueToWaitUntilCompleted:
                "После проверки QR-кода он автоматически переключится на заполненное поле. Пожалуйста подождите...",
            authenticatingWait: "Аутентификация, пожалуйста, подождите...",
            enableFeature: "Включить функцию WhatsApp",
            readAndAgree: "Я подтверждаю прочитал",
            subscribe: "Подписаться",
            subscribed: "Подписан",
            toEnableWpDescription: "Чтобы включить функции WhatsApp, нажмите кнопку ниже.",
            waitForWpActivationDescription:
                "Служба вашей учетной записи WhatsApp активируется. Пожалуйста, подожди минутку. Это занимает около 10-30 секунд.",
            greatWpActivatedDescription: "Отлично, услуга «Ваша учетная запись WhatsApp» активирована!",
            unsubscribe: "Отписаться",
            planDetails: "Детали интеграции",
            sendReceiveMessage: "Отправка и получение текстовых сообщений",
            sendReceiveImage: "Отправка и получение файлов изображений",
            sendReceiveAudio: "Отправка и получение аудиофайлов",
            sendReceiveGif: "Отправка и получение файлов GIF",
            startChat: "Начать чат на Supsis",
            supsisFunctionality: "Полезный функционал Supsis Chat",
            onePhoneMultiAgent: "Один телефон и несколько агентов",
            basicIntegration: "Базовая интеграция и нулевая конфигурация",
            unsubscribeWpInetgration: "Отписаться от WhatsApp",
            wpBack: "назад",
            terminatelWpInetgration: "При нажатии кнопки «Отписаться» ваша интеграция с WhatsApp прекратится.",
            cancelWpInetgration: "Вы хотите отменить интеграцию WhatsApp?",
            startChatWp: "Начать Чат",
            purchaseHeader: "Покупка интеграции Supsis-Whatsapp",
            wpServices: "Служба WhatsApp",
            wpServicesIntegrationCompleted:
                "Ваша интеграция WhatsApp завершена. Теперь вы можете пользоваться сервисом.",
            purchasePaymentDescription:
                "Функция WhatsApp оплачивается ежемесячно. Ваша служба WhatsApp будет активирована после того, как вы примете подписку.",
            wpIntegrationFeatures:"Возможности интеграции WhatsApp",
        },
        ticket: {
            ticketTagFilter: "Тег фильтра билетов",
            ticketEmails: "Список рассылки для пересылки билетов",
            save: "Сохранить",
            delete: "Удалить",
            transactions: "Параметры",
            noEmailTicketNotifications: "Нет данных",
            emailIsNotValid: "Email не является допустимым",
            emailNotificationDeleted: "Товар удален успешно",
            emailNotificationDeleteError: "Произошла ошибка",
            tagFilterRequired: "Требуется тег фильтра заявки, используйте тег * (подстановочный знак) для всех заявок",
            emailsRequired: "Пересылка писем не должна быть нулевой",
            emailNotificationCreated: "Создано правило пересылки билетов",
            emailNotificationCreateError: "Произошла ошибка",
            ticketForwarding: "Пересылка билетов по электронной почте",
            ticketTagFilterDesc:
                "Он использует темы тикетов, которые вы использовали в дизайне чат-бота, для фильтрации тикетов. Вы можете написать другой тег и нажать Enter, чтобы добавить его. Если вы выберете тег '*', он выберет все билеты",
            ticketEmailsDesc:
                "Список адресов электронной почты, на которые будут отправлены билеты. Вы можете добавить адреса представителей в систему, выбрав их. Вы также можете добавить несистемные адреса электронной почты.",
            ticketList: "Правила пересылки билетов",
            ticketTagFilterPlaceHolder: "Фильтр билетов, выберите '*' для всех",
            ticketEmailsPlaceHolder: "Список рассылки для пересылки",
        },
        theme: {
            opacity: "Непрозрачность",
            headerColor1: "Секция Хадера, цвет 1",
            headerColor1A: "Непрозрачность раздела Хадера 1",
            headerColor2: "Цвет раздела заголовка 2",
            headerColor2A: "Непрозрачность раздела заголовка 2",
            backgroundColor: "Цвет фона 1",
            backgroundColorA: "Прозрачность фона 1",
            backgroundColor2: "Цвет фона 2",
            backgroundColor2A: "Прозрачность фона 2",
            textColor: "Цвет текста",
            errorTheme: "Цвет ошибки",
            bubbleBackground: "Цвет фона пузыря чата",
            bubbleBackgroundA: "Прозрачность фона пузыря чата",
            bubbleText: "Цвет текста пузыря чата",
            selectCustom: "Выберите настраиваемую тему",
        },
        billing: {
            invoice: "Инвойс",
            mustBeUpgradePlanForChatBot: "Чтобы активировать функцию ChatBot, вы должны перейти на тариф Pro!",
            cardInfo: "Информация о карте",
            billingDetails: "Платежные реквизиты",
            addCardIyzico:
                "У вас нет зарегистрированной карты. Чтобы оплачивать ежемесячную плату за использование, вам необходимо добавить карту. Платежная система предоставляется iyzico.",
            billingPlanSettings: "Биллинг и счет-фактура",
            startWith: "Карточка {cardFamily} начинается с {binNumber}",
            paymentMethod: "Способ оплаты",
            billingDate: "Дата оплаты",
            isPaid: "Платеж получен?",
            paid: "Оплаченный",
            markPaid: "Отметить как оплаченное",
            paymentDate: "Дата платежа",
            pay: "Платить",
            newInvoice: "Создать счет-фактуру",
            updateBilling: "Обновить платежную информацию",
            updateCard: "Сменить кредитную карту",
            paymentBilling: "Метод Paymnet и платежные реквизиты",
            price: "Цена",
            billingAddress: "Платежный адрес",
            billingCity: "Город",
            billingCountry: "Страна",
            contactName: "Имя контактного лица по счетам",
            expireMonth: "Срок действия месяца",
            expireYear: "Год истечения",
            cardNumber: "Номер карты",
            cardHolderName: "Имя владельца карты",
            cardAlias: "Псевдоним карты",
            identityNumber: "Идентификационный номер",
            name: "Имя",
            surname: "Фамилия",
            email: "Эл. адрес",
            addCard: "Добавить карту",
            update: "Обновлять",
            cancel: "Отмена",
            save: "Сохранить",
            saving: "Экономия",
            noInvoiceFound: "Нет счета",
            year: "Год",
            updating: "Обновление...",
            newInvoiceForm: "Форма создания нового счета",
            error: "Ошибка",
            transactions: "Параметры",
            paymentMethodAdded: "Способ оплаты успешно добавлен",
            paymentMethodAddError: "Способ оплаты не добавлен, произошла ошибка",
            creditCardChanged: "Кредитная карта успешно изменена",
            errorOccurred: "Произошла ошибка, попробуйте еще раз",
            billingDetailUpdated: "Платежная информация успешно обновлена",
            invoiceCreated: "Счет-фактура успешно создана",
            paymentSuccess: "Оплата прошла успешно, спасибо",
            paymentFail: "Платеж не прошел, попробуйте еще раз",
            billingAddressChanged: "Платежный адрес успешно изменен",
            hidePlan: "Скрыть план",
            informationShopping:
                "Ваша платежная информация, платежная информация, информация о кредитной карте контролируются Shopify.",
            trialTimeInformation:
                "Пробная версия заканчивается через {dayCount} дней после. Если вы не укажете способ оплаты до истечения этого периода, система автоматически переключит вас на БЕСПЛАТНЫЙ ПЛАН.",
            trialTimeInformationShort: "Последний {dayCount} День",
            currentPlanLabel: "Текущий план: {planName} ({agentCount} Агент )",
            changeCancelPlan: "Изменить / отменить тарифный план",
            oneAgent: "Агент",
            agent: "Агент",
            yourCurrentPlan: "Текущий план",
            month: "Месяц",
            billedMonthToMonth: "(выставляется счет от месяца к месяцу)",
            selectAgentCount: "Выберите количество агентов",
            selectFreePlan: "Выберите бесплатный план",
            planDetails: "Детали плана",
            multiAgent: "(Мультиагент)",
            selectProPlan: "Выберите план Pro",
            foreverFree: "Вечно свободный",
            websiteIntegration: "интеграция с сайтом",
            websiteIntegrationUnlimited: "интеграция с сайтом (неограниченный)",
            ChatBotUnlimited: "ChatBot (неограниченный)",
            videoCallUnlimited: " видеозвонок (неограниченный)",
            multiAgentUpTo: "Мультиагент (до {agentCount} агентов)",
            audioCallUnlimited: "Аудиовызов (неограниченный)",
            screenSharingUnlimited: "Совместное использование экрана(неограниченный)",
            fileTransferUnlimited: "Передача файлов (неограниченный)",
            autoChatAssignerUnlimited: "Автоматическое назначение чата (неограниченный)",
            multiLanguageTranslationUnlimited: "Многоязычный перевод (неограниченный)",
            detailedReporting: "Подробная отчетность",
            days30TrialsAvailable: "Доступны 30-дневные пробные версии",
            fullCustomizationUnlimited: "Полная настройка (неограниченный)",
            limitedArchiveLookupLastMo: "Ограниченный архив Поиск (Последний {monthCount}-мес)",
            planUpdated: "Отлично, ваш план обновлен.",
            planUpdating: "Ваш план обновляется...",
            planUpdatingDescription: "Подождите, пока ваш план обновится",
            done: "Выполнено",
            freePlanUpdated: "Ваш план обновлен как бесплатный (1 Агент)",
            proPlanUpdated: "Ваш план обновлен как план PRO {agentCount} Агент ",
            canNotDwnGrade:
                "Невозможно понизить ваш тарифный план с PRO {agentCountFirst} Агент до {valNewPlnToUppr} {agentCountSecond}.  ",
            deleteWarning: "Вы должны удалить или отключить {valDif} Агент.",
            warnMessage: "Выбранный план должен отличаться от текущего.",
            add: "Добавлять",
            cancelYourPlan: "Отменить тарифный план",
            upgradeYourPlan: "Обновите свой план",
            downgradeYourPlan: "Понизьте свой план",
            agree: "ДАТЬ СОГЛАСИЕ",
            disagree: "Не согласен",
            invoices: "Счета",
            priceIntervals: "Ценовой интервал",
            selectSiteAlias: "Выберите или введите название сайта",
            selectPriceInterval: "Выберите или введите ценовой интервал",
            isRefunded: "Возврат сделан?",
            invoiceId: "Счет №",
            siteId: "Сайт №",
            createdDate: "Дата создания",
            failCount: "Счетчик неудачных платежей",
            failDate: "Неудачная дата платежа",
            Dashboard: "Панель приборов",
            Agents: "Агенты",
            Integration: "Интеграция",
            Settings: "Настройки",
            Contacts: "Контакты",
            Domain: "Домен",
            lastActivity: "Последняя активность",
            basePrice: "Базисная цена",
            packagePrice: "Базисная цена",
            whatsappPrice: "WhatsApp Цена",
            realtimeVisitorCount: "Посетитель в реƒжиме реального времени",
            suspend: "Приостановить",
            partner: "Партнер",
            plan: "Строить планы",
            trialDay: "Пробные дни",
            mobile: "Мобильный",
            webSite: "Веб-сайт",
            websiteOrigins: "Происхождение веб-сайта",
            ownerName: "Имя владельца",
            ownerEmailAddress: "Электронная почта владельца",
            discount: "Скидка",
            daysLeft: "Осталось дней",
            newTrialPopUp: "Сколько дней должен длиться новый пробный период?",
            newWpPricePopUp: "Сколько стоит новый тариф WhatsApp?",
            newBasePricePopUp: "Сколько стоит новая базовая цена?",
            siteInfoUpdated: "Информация о сайте обновлена",
            siteInfoNotUpdated: "Информация о сайте не обновлена",
            siteInfoNotUpdatedErr: "Произошла ошибка! Информация о сайте не обновлена.",
        },
        chatbot: {
            link: "Бот отправит ссылку в виде сообщения",
            linkTitle: "Название ссылки",
            linkAddress: "Адрес ссылки",
            goto: "Бот вернется к указанному вами шагу",
            text: " Бот отправит ваш текст в виде сообщения",
            randomText:
                "Бот случайным образом выберет один из предоставленного вами текстового списка и отправит его в виде сообщения. ",
            image: " Бот отправляет загруженное изображение в виде визуального сообщения ",
            ticket: " Бот открывает тикеты в систему, чтобы решить проблемы посетителей, которые перейдут на этот этап позже.",
            ticketTopic: " Это предмет билета. Когда бот открывает заявку, он отмечает эту тему ",
            ticketMessage:
                " После того, как бот откроет заявку, введите здесь сообщение, которое он отправит пользователю. ",
            button: " Позволяет боту предлагать выбор другой стороне ",
            question: " Позволяет боту задавать вопросы для получения информации от пользователя. ",
            prev: " Это позволяет вернуться в предыдущее верхнее меню. ",
            closeChat: " Разговор прекращается после отправки сообщения ботом. ",
            transferLiveChatOption:
                " Эта опция появляется в выборе меню, посетитель может щелкнуть и передать разговор живому представителю. ",
            delay: " Сообщение отправляется после уведомления о том, что сообщения хранятся в течение определенного периода времени, и запись представителя пропала. ",
            upload: " Нажмите, чтобы скачать изображение ",
            imageView: " Нажмите, чтобы просмотреть изображение в большом размере ",
            finishStep: " После этого шага беседа будет закрыта автоматически. ",
            warnStep:
                " После этого шага бот перенаправит вас к живому агенту, так как вы не добавили больше шагов или не отключили функцию разговора. ",
            deleteChatBotStepQuestion: "Вы уверены, что хотите удалить этот шаг?",
            chatbotStepWasDeleted: "Успешно удалено",
            deleteMessageQuestion: "Вы уверены, что хотите удалить это сообщение",
            startToDesign: "НАЧАТЬ ДИЗАЙН",
            keywords: "КЛЮЧЕВЫЕ СЛОВА",
            typeKeyword: "Введите ключевое слово",
            snDelay: "{delay} сек задержка",
            welcome: "Добро пожаловать",
            untitled: "Без названия",
            untitledMenu: "Без названия",
            menuMessage: "Сообщение ввода меню",
            selection: "Выбор",
            addNewButton: "Добавить новую кнопку",
            questionMessage: "Введите свой вопрос, сообщение..",
            userName: "Имя пользователя",
            untitledForm: "Без названия",
            descriptionUserName: "Пожалуйста, введите имя пользователя",
            makeChoice: "Сделай свой выбор",
            subject: "Тема",
            menu: "Меню",
            contentTitle: "Заголовок содержимого",
            subjectTitle: "Заголовок темы",
            buttonTitle: "Название кнопки",
            ticketSuccesfull: "Билет успешно оформлен",
            randomTextPlaceHolder: "Случайный текст",
            yes: "да",
            no: "Нет",
            questionLabel: "Введите тег вопроса ..",
            onlyImage: "Вы можете загружать только изображения!",
            imageSize: "Размер вашего изображения должен быть максимум {size}.",
            types: {
                text: "ТЕКСТ",
                image: "ИЗОБРАЖЕНИЕ",
                ticket: "ПРОЕЗДНОЙ БИЛЕТ",
                random: "СЛУЧАЙНЫЙ",
                goto: "ПЕРЕЙТИ К",
                link: "ССЫЛКА НА САЙТ",
            },
        },
        tour: {
            stats: " ПАНЕЛЬ СТАТИСТИКИ ",
            chats: " ЧАТ ПАНЕЛЬ ",
            settings: " НАСТРОЙКИ ",
            status: " СТАТУС ",
            prevStep: " Предыдущий шаг ",
            nextStep: " Следующий шаг ",
            finish: " Закончи это ",
            skip: " Прыжок ",
            skip2: " Я знаю систему, больше не показываю",
            startTour: "Начать тур",
            firstTimeIntro:
                " Я обнаружил, что вы впервые вошли в систему, если вы позволите, я хочу начать небольшой вводный тур. ",
            hi: " Привет ",
            welcomeTo: " Добро пожаловать в службу поддержки Supsis Live ",
            statsPanel:
                " Это строка состояния, показывающая общее количество активных номеров чата, которые мгновенно ожидают вместе с системой.",
            sidebarMenu: " Меню ",
            sidebarMenuContent: " Здесь вы можете переключаться между страницами.",
            representativePrivateMessage: "Межпредставительская дискуссионная панель",
            representativePrivateMessageContent: " Здесь вы можете увидеть личные разговоры между агентами.",
            helpMenu: "Меню помощи",
            helpMenuContent: " Здесь вы можете найти справочную информацию о системе.",
            settingsMenu: " Меню настроек ",
            settingsMenuContent: " Здесь вы можете выбрать язык, ночной режим и увеличение экрана.",
            startChat: "Начать Чат",
            profileMenu: " Меню профиля ",
            profileMenuContent: " Здесь вы можете изменить доступность и настроить параметры делегата.",
            visitorsTab: " Посетители ",
            visitorsTabContent: " Вы можете увидеть посетителей здесь. ",
            visitorTabHistory: " История посетителей ",
            visitorTabHistoryContent: " Вы можете увидеть историю посетителей здесь.",
            representativeTab: " Представители ",
            representativeTabContent: " Вы можете увидеть представителей здесь.",
            liveSupport: " Живая поддержка ",
            liveSupportContent:
                " Здесь вы можете увидеть количество клиентов, получающих поддержку в реальном времени.",
            siteVisitors: "Посетители сайта",
            siteVisitorsContent: " Здесь вы можете увидеть количество посетителей сайта.",
            tableSettings: " Настройки стола ",
            tableSettingsContent: "Отсюда вы можете показать или скрыть столбцы в таблице.",
            watchModeButton: "Кнопка просмотра",
            watchModeContent:
                " Вы можете присоединиться сюда в режиме просмотра, и вы можете просматривать только то, что было опубликовано.",
            popoverInfo: " Подробная информация о посетителе ",
            popoverInfoContent: " Дает информацию о посетителе.",
            popoverButton: " Расширенные настройки речи ",
            popoverButtonContent:
                " Вы можете открыть беседу, отправить сообщение напрямую представителю или заблокировать посетителя.",
            openChat: " Кнопка: Присоединиться к разговору",
            openChatContent: " Вы можете начать разговор здесь ",
            pagination: " Меню подкачки.",
            paginationContent: " Здесь вы можете увеличить количество страниц.",
            chatwindow: {
                chatWindowSettingsButtons: " КНОПКА НАСТРОЕК ОКНА РАЗГОВОРА ",
                chatWindowActionButtons: " ОКНО РЕЧИ КНОПКИ ОБЩИХ ОПЕРАЦИЙ ",
                chatPanelActions: " РАБОТА С РЕЧНОЙ ПАНЕЛЬЮ ",
                otherPanels: "ДРУГИЕ ПАНЕЛИ",
                settingsButton:
                    "Вы можете заблокировать речь, пересылку, конфиденциальное сообщение и назначить делегатов.",
                chatColorButton: " Вы можете узнать, что означает цвет в речевых пузырях, здесь.",
                keyboardShortcutButton:
                    " Здесь вы можете найти ярлыки для функций, которые упрощают ведение переписки или других функций, которые вы используете. ",
                hideButton: "Откладывает открытое выступление и остается открытым на заднем плане",
                closeButton: " Вы заканчиваете откровенный разговор и уходите из разговора ",
                ellipsisButton:
                    " Сюда включены другие транзакции. Здесь выполняются такие операции, как отправка личных сообщений, запрет посетителей, назначение представителей. ",
                userInfoWidget: " Подробная информация о посетителе будет доступна здесь. ",
                preparedContentWidget:
                    "Есть готовые шаблоны контента. Вы можете быстро добавить готовый контент, щелкнув ярлык или набрав серию ярлыков в области письма на экране речи.",
                chatHistoryWidget:
                    " Если у этого посетителя есть прошлые разговоры, они будут перечислены здесь. Вы можете просмотреть старые детали речи здесь ",
                chatBarButton:
                    " Здесь вы можете заблокировать активный разговор, отправить личное сообщение агенту и выйти из разговора.",
            },
        },
        message: {
            chatLanguage: "Язык чата",
            translating: "Идет перевод",
            buyWhatsapp: "Приобрести интеграцию с WhatsApp",
            liveSupportStartingWait: "Запуск поддержки в режиме реального времени, пожалуйста, подождите",
            integrations: "Интеграции",
            refundInvoiceSure: "Вы уверены, что хотите вернуть счет?",
            invoiceMarkedAsPaidSuccess: "Счет отмечен как успешно оплаченный",
            invoiceMarkedAsPaidError: "Ошибка, счет не помечен как оплаченный",
            deleteConfirm: "Вы хотите удалить этот {object}?",
            markPaidConfirm: "Вы уверены, что пометите этот счет как оплаченный?",
            startChatDesc: "Начать разговор",
            addLink: "Ссылка на сайт",
            selectStep: "Выберите шаг:",
            addGOTO: "Перейти к",
            sendFastLink: "Отправить Fast Link",
            or: "или",
            allTags: "Все теги",
            showDetail: "Показать детали",
            hideDetail: "Скрыть детали",
            weLlSendPhone: "Мы отправим на ваш телефон",
            weLlSendEmail: "Мы отправим на Ваш e-mail",
            linkSentToPhone: "Ссылка отправлена в смс",
            offerlinkSendToPhone: "Мы вышлем вам ссылку для скачивания нашего приложения в SMS.",
            offerlinkSendToMail: "Мы вышлем вам ссылку для скачивания нашего приложения в Почта.",
            theEmail: "Моя зарегистрированная электронная почта",
            differentEmail: "Другое электронное письмо",
            linkSentToMailBox: "Ссылка отправлена на ваш почтовый адрес",
            errorOccurred: "Произошла ошибка !",
            clickStoreIcon:
                "Вы можете получить доступ к мобильному приложению, нажав на значок, подходящий для вашего телефона.",
            meetWithSupsis: "Хотите познакомиться с нашим мобильным приложением SUPSIS?",
            downloadMobileApps: "Скачать мобильное приложение",
            getApps: "Получить приложения",
            info: "Информация",
            conversationHistory: "История разговоров",
            planInfoHeader: "Информация о плане",
            planInformation: "Ваш тарифный {selectedPlan} план ({detailMaxAgentCount} агент) ",
            creditAvailable: "Ваш агентский кредит доступен в вашем плане: ",
            upDownGradePlan: "Если вы хотите повысить / понизить свой тарифный план, пожалуйста",
            click: "Нажмите",
            autoStartChat: "Автоматический запуск чата",
            bubbleColor: "Цвет пузыря чата",
            openFolder: "Открыть папку",
            preDefined: "Темы",
            customIcon: "Установить со своего компьютера",
            theme: "Тема",
            themeSettings: "Настройки темы",
            bubbleSettings: "Настройки пузыря чата",
            bubbleIcon: "Изображение пузыря чата",
            autoHideBubble: "Скрыть пузырь чата",
            vtippyAutoHideBubble: "Скрывает всплывающее окно чата, когда агенты не в сети",
            deleteSite: "Вы хотите удалить сайт?",
            assetOversizeWithExt: "Размер файла должен быть менее 10 МБ и в формате png, jpg.",
            all: "Все",
            allDepartments: "Все отделы",
            preferredLanguage: "предпочтительный язык",
            kmkAutoDepartmentBind: "KMK Поиск автоотдела",
            kmkAutoDepartmentBindDesc:
                "Найдите продавца на сайтах клиентов KMK и настройте страницу входа в качестве отдела",
            chatBot: "Чат-бот",
            ticketResponse: "Представительский ответ:",
            archived: "Архив",
            chatbotChatCount: "ЧАТБОТ",
            visitorEmailUpdated: "Электронная почта посетителя обновлена",
            visitorEmailIsNotValid: "Электронная почта посетителя недействительна",
            visitorNameUpdated: "Имя посетителя обновлено",
            clickToEdit: "Нажмите, чтобы изменить",
            addEmail: "+ Добавить электронную почту",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Интеграция?",
            agentCount: "Количество агентов",
            closePreviewColors: "Закрыть предварительный просмотр темы",
            previewColors: "Открыть предварительный просмотр темы",
            videoCalls: "Видеозвонки",
            filterLost: "Потерянные чаты",
            vtipyCustomLogin:
                "Вы можете настроить информацию, которая будет запрашиваться в форме входа, когда ваши посетители подключаются к системе.",
            vtipyLoginlessChat: "Форма входа посетителя будет скрыта. Посетитель может подключиться к чату напрямую.",
            loginlessChat: "Форма входа посетителя видна",
            imageUrl: "URL изображения",
            openImage: "Открыть изображение",
            writeFeedback: "Вы можете написать свой отзыв о SUPSIS здесь.",
            feedbackFailed: "Ошибка при отправке отзыва.",
            feedbackSuccessful: "Отзыв отправлен.",
            sendFeedback: "Отправить отзыв",
            errorReport: "Вы можете сообщить нам о своих проблемах с SUPSIS.",
            sendErrorFeedBack: "Поделитесь с нами своим мнением о проблеме, с которой вы столкнулись.",
            successImgUpload: "Ваше изображение было успешно загружено.",
            errorImgUpload: "Произошла ошибка при загрузке вашего изображения.",
            chatBotEndStatics: "Коэффициент успешности разговора с чат-ботом",
            videoCallDist: "Распределение видеозвонков",
            departmentInfo: "Информация об отделе",
            infoAboutDepartment: "Дайте краткую информацию об отделении",
            deleteDepartmentQuestion: "Вы действительно хотите удалить этот отдел?",
            departmentDeleted: "Отдел удален",
            departmentTitle: "Название отдела",
            updateDepartmentForm: "Форма обновления отдела",
            newDepartmentForm: "Форма нового отдела",
            department: "отделение",
            newDepartment: "Новый отдел",
            departmentSaved: "Отдел сохранен",
            departments: "Отделы",
            chatTimingSettings: "Настройки времени чата",
            assetOversize: "Размер отправляемого файла не должен превышать 2 МБ.",
            messageDeleted: "Это сообщение удалено",
            filterVideoCall: "Фильтр видеозвонков",
            filterLostChat: "Фильтры Потерянные чаты",
            notificationText: " Супсису нужно разрешение на",
            deniedText:
                "Ваши уведомления закрыты, вам нужно включить свои уведомления, чтобы не пропустить своих клиентов.",
            showNotificationGuide: "Нажми для деталей",
            howToEnableNotification: "Как я могу включить уведомления",
            notificationOK: "Ok",
            notificationCancel: "Отмена",
            howToEnableNotificationInstruction1: "Нажмите на значок замка в адресной строке браузера",
            howToEnableNotificationInstruction2: "Если «Уведомления» отключены в разделе «Разрешения», включите их.",
            howToEnableNotificationInstruction3:
                "Если «Уведомления» не отображаются в разделе «Разрешения», нажмите «Настройки сайта».",
            howToEnableNotificationInstruction4:
                "Включите разрешение «Уведомления» в разделе «Разрешения» на странице настроек сайта.",
            checkPaymentMethod: "Пожалуйста, проверьте способ оплаты",
            pushNotificationEnabled: "Отлично, Push-уведомление включено",
            pushNotificationDenied: "Вы отказали в разрешении на уведомление",
            suspendedMessage: "Ваша учетная запись была приостановлена",
            enableNotification: "Включите уведомления на рабочем столе.",
            languageSettings: "выбранный язык",
            problemsSound:
                "Если у вас возникли проблемы с уведомлениями, вы можете щелкнуть изображение блокировки в окне поиска браузера (показано на рисунке), щелкнуть «Настройки сайта» и изменить «Звук» на «Разрешить».",
            betweenRepresentative: "Есть новое сообщение от представителя",
            desktopNotifications: "Уведомления на рабочем столе",
            notificationEnabled: "Уведомления на рабочем столе SUPSIS включены.",
            newMessageAlert: "У вас есть новое сообщение.",
            notificationDisable: "Вы можете отключить уведомление в настройках представителя",
            newConversationAlert: "У вас новый посетитель.",
            autoLoadIframe: "Живой трафик",
            autoLoadIframeDesc: "Автоматически загружать iframe, пропускать весь трафик посетителей",
            enableState: "Активный?",
            requiredFieldField: "Это поле обязательно к заполнению",
            catalogCategoryMenu: "Добавить меню категории каталога",
            catalogCategoryLeaf: "Добавить подменю категории каталога",
            closeChat: "Завершить обмен сообщениями",
            ticket: "Билет",
            formStep: "Шаг формы",
            menuStep: "Шаг меню",
            contentStep: "Шаг содержания",
            menuTitle: "Заголовок меню",
            messageContent: "Содержание сообщения",
            goToLive: "Передача представителю",
            prevStep: "Вернуться к предыдущему шагу",
            addButton: "Кнопка",
            addImage: "Изображение",
            addText: "Текст",
            stepTitle: "Название шага",
            addTicket: "Проездной билет",
            formDescription: "Вопрос",
            addInput: "Вопрос",
            addRandomText: "Случайный текст",
            changeTitle: "Изменить заголовок",
            catalog: "Название каталога",
            openTheCatalog: "Открытый каталог",
            catalogNotOpen:
                "Функция каталога отключена. Вы можете включить функцию каталога, чтобы поддерживать своих клиентов заранее подготовленным контентом. ",
            showCatalogCategories: "Измените способ отображения меню каталога в пузыре чата. ",
            showChatBot: "Измените статус меню чат-бота, чтобы он отображался в пузыре чата.",
            openCatalog: " Каталог ",
            unreadMessages: " Непрочитанные сообщения ",
            personalFirstMsg: " Среднее время ответа сотрудников на первое сообщение",
            personalRating: " Средний балл персонала",
            soundSettings: " Настройки звука ",
            newPrivateMessage: " Личное сообщение ",
            newMessage: " Новое сообщение ",
            newConversation: "новый чат ",
            newVisitor: " Новый посетитель ",
            chatPosition: " Расположение чата ",
            chatPositionSelect: " Выберите место ",
            bottomLeft: " Внизу слева ",
            left: "Слева",
            bottomRight: "Внизу справа ",
            right: "Справа",
            mailorname: " Электронная почта или имя ",
            breaksByTime: " Количество перерывов по времени ",
            clPlaceholder: " Имя, которое будет отображаться в форме клиента ",
            fieldName: " Имя ключа ",
            value: "Значение",
            addSetting: " Добавить новую настройку ",
            globalSettings: "Общие настройки",
            target: " Адрес нагрузочного теста ",
            duration: " Время нагрузочного теста(сек)",
            arrivalCount: " Количество ботов(шт)",
            bootMaxLife: "Время жизни бота(сек)",
            startLoadTest: " Начать нагрузочный тест ",
            noClusterInstanceFound: "Сервер не найден",
            stopLoadTest: " Завершить нагрузочный тест ",
            integrationDesc: "Просто добавьте на свой сайт приведенный ниже однострочный код.",
            integrationDemoCode: " Пример демо кода интеграции ",
            integrationWindow: " Как мне интегрировать мой сайт?",
            notIntegrated: "интеграции",
            help: " Помощь",
            notIntegratedDesc:
                " Мы поняли, что вы не добавляли чат на свой сайт. Когда вы интегрируете его на свой сайт и начнете первый разговор, вы завершите интеграцию. Нажмите, чтобы увидеть СЦЕНАРИЙ ИНТЕГРАЦИИ ",
            backToLogin: " Войдите снова",
            passwordlessLoginUnsuccessful:
                " Ошибка входа. Возможно, срок действия ссылки для входа истек или она использовалась ранее.",
            passwordlessLogin: " Вход без пароля ",
            loginWithEmail: "Войти по электронной почте",
            loginWithPassword: "Войти с паролем",
            enteringPasswordless: " Войти без пароля ...",
            toMainPath: " Перенаправить на домашнюю страницу ",
            userRoleChanged: " Ваши права доступа изменились. Вы попадете на главную страницу, чтобы продолжить.",
            passwordChangeSuccess: " Ваш пароль успешно изменен ...",
            feedback: " Обратная связь ",
            showFeedbackHistory: " Показать сообщения, на которые были отправлены отзывы.",
            newSelfServiceSite: " Новый сайт самообслуживания ",
            subdomain: "Субдоменное имя",
            rootUserEmail: "Электронная почта пользователя",
            rootUserName: "Ваше имя",
            newVersion: "Доступна новая версия",
            newVersionShort: "новая версия",
            bannedWordRestrict: " Блокировка запрещенных слов ",
            bannedWordRestrictDesc:
                " Когда включена блокировка запрещенных слов, представителям запрещается вводить посетителям запрещенные слова, определенные в системе. ",
            agentDown: " Представитель отлючился",
            delayChat: " Отложенный чат ",
            tableSettingTippy: "Здесь вы можете изменить информацию, которая будет отображаться в таблице.",
            tableSettings: " Настройки таблицы",
            tableSettingsInfo:
                " Здесь вы можете изменить информацию, которая будет отображаться в таблице. Вы можете выбрать до 7 столбцов ",
            cityAndDistrict: " Город / Район ",
            general: " Общий ",
            home: "Главная",
            successful: " Успешно ",
            forgetPasswordSent: " Письмо для сброса пароля отправлено, проверьте свою электронную почту.",
            saturday: " Суббота ",
            friday: " Пятница ",
            thursday: " Четверг ",
            wednesday: "Среда ",
            tuesday: " Вторник ",
            monday: " Понедельник ",
            sunday: " Воскресенье ",
            download: " Скачать",
            calendarPassedTimeHour: "{час} время {имя}",
            calendarPassedTime: "{час} время {мин} мин {имя}",
            calendarPassedTimeMinSec: "{мин}час{сек}сек{имя}",
            calendarPassedTimeMin: "{значение} мин {имя}",
            calendarPassedTimeSec: "{час} часы {мин} мин {сек} сек {имя}",
            workScheduleOneDay: "График работы на {sDate} день пользователя по имени {name} ",
            workSchedule: "График работы с {sDate} - {eDate} от {name} ",
            calendar: "Календарь",
            noRating: " Нет подсчета оценок ",
            rateDist: " Диаграмма распределения оценок ",
            distConversation: "Диаграмма распределение разговоров",
            totalWhatsappChatCount: "чатов в Whatsapp",
            statsByTime: " Количество диалогов по времени",
            selectRep: " Выберите представителя ",
            allRepresentatives: "Все представители",
            avgRating: " Распределение оценок ({оценка}) ({count} оценка)",
            avgFirstMessageTime: " Среднее время первого ответа ",
            totalBreakTime: "Перерыв",
            totalBreakNum: "Количество перерывов",
            averageConTime: "Среднее время разговора",
            longestConTime: " Самое долгое время разговора",
            shortestConTime: " Наименьшее время разговора",
            refresh: "Обновить",
            waitingReply: "В ожидании ответа",
            organizationName: " Название организации",
            messageSentErr: "Сообщение не может быть отправлено, попробуйте еще раз.",
            messageSent: " Сообщение отправлено.",
            openPrivateChat: "Открыть межпользовательский диалог ",
            escKey: " Скрыть активный диалог ",
            privateChat: " Межпредставительская дискуссионная панель ",
            multiModeAlertDesc:
                " SUPSIS открыт в другом окне. Нажмите «Использовать здесь», чтобы использовать SUPSIS в этом окне. ",
            useHereText: " Используйте здесь",
            brandVisibility: "Тег бренда SUPSIS появляется в иконке чата",
            focusInput: " Наведите курсор на область письма активного диалога",
            send: "Отправить",
            notYet: "Еще нет",
            sending: "Отправка",
            onlyRepresentative: "Ваше сообщение увидят только агенты.",
            yourMessage: "Ваше сообщение",
            notValid:
                "Вы можете вводить только буквы (один символ). Буквы e, d, f, z, a, x, c, v, w, t, n недействительны ",
            forMacUsers: " Пользователи Mac могут использовать клавишу Control (⌃) ",
            basePriceValue: "Базисная цена",
            basePriceDiscount: "Скидка",
            basePriceCurrency: "Валюта",
            customerDBEnabled: " Выбор базы данных: используйте собственный сервер базы данных клиента",
            customerDBDisabled: " Выбор базы данных: используйте базу данных Supsis сервер ",
            mongoConnectionString: " Подключение Мongo ",
            whatsappBasePriceValue:"Базовая цена WhatsApp",
            clientAddress: " Адрес клиента",
            customerClientAddress: "Клиентский адрес посетителя ",
            apiAddress: " Адрес API",
            socketAddress: "Soket адрес ",
            backendAddress: "BackEnd Адрес",
            panelLogoUrl: " Адрес логотипа панели",
            panelCustomCssUrl: " Адрес пользовательской панели Css ",
            customerLogoUrl: " Адрес логотипа клиента ",
            customerCssUrl: " Адрес CSS клиента ",
            siteAlias: " Название сайта",
            language: "Язык",
            features: "Функции",
            represantativeSettings: "Настройки представителя",
            chatBalloonTehemeSettings: "Настройки иконки чата и темы",
            customLoginFormSettingsTitle: "Специальная форма входа",
            addNewField: "Добавить новый вопрос",
            editField: " Редактировать вопрос",
            typeHere: " Введите здесь",
            pco: "СРП",
            perPage: "/страница",
            startFilter: "Начать поиск",
            showMyChats: " Показать мои чаты",
            showOnlineAgents: " Показать только онлайн",
            showWaitingChats: " Показать ожидающих представителя",
            newTitleContent: " Добавить заголовок ",
            roleName: "Название должности",
            error: " Ошибка ",
            contentType: " Тип содержимого",
            contentTitle: " Заголовок содержимого ",
            newSiteForm: " Форма регистрации нового сайта ",
            updateSiteForm: " Форма обновления сайта",
            newBannedWordForm: " Новая форма регистрации запрещенных слов",
            updateBannedWordForm: "Форма обновления запрещенного слова",
            newWelcomeMessageForm: "Форма регистрации нового приветственного сообщения",
            updateWelcomeMessageForm: "Форма обновления приветственного сообщения",
            newDefaultContentForm: " Форма регистрации нового готового контента ",
            updateDefaultContentForm: "Форма обновления готового контента",
            newSubjectForm: " Форма регистрации новой темы ",
            updateSubjectForm: " Форма обновления темы ",
            showIntro: " Показать презентацию ",
            showChatColorMeaning: " Цвета чата ",
            options: " Опции ",
            resetPassword: " Сброс пароля ",
            audioLevel: " Громкость звукового предупреждения ",
            privateChatNotificationSound: " Звук уведомления",
            continue: " Продолжить",
            newRoleForm: " Форма регистрации новой должности",
            updateRoleForm: " Форма обновления должности ",
            newUserForm: " Форма регистрации нового пользователя",
            updateUserForm: " Обновить форму пользователя ",
            changeOSRForm: " Изменить офлайн-сообщение ",
            tooltipOSRForm: " Вы можете изменить офлайн-сообщение.",
            newOSRForm: " Форма офлайн-поддержки ",
            newOSRMessages: " Добавить автономное сообщение ",
            updateOSRForm: " Форма офлайн-обновления",
            osrTitle: " Заголовок ",
            osrTitleDescription: " Вы можете добавить заголовок в форму офлайн- поддержки ",
            osrContent: " Содержание",
            osrContentDescription: " Вы можете добавить содержание в форму офлайн-поддержки ",
            hello: " Привет мир",
            date: " История ",
            startDate: " Дата начала ",
            finish: "Закончить",
            start: "Начать",
            search: " Поиск",
            endDate: " Дата окончания",
            representative: " Представители",
            representative_: " Представитель",
            star: "Оценка",
            filter: "Фильтр",
            reset: "Сброс настроек",
            dailyChatList: " Список ежедневных диалогов",
            dailyChatDuration: " Ежедневное время диалогов",
            chatDuration: " Время диалогов",
            dailyChatGraph: " Таблица ежедневных диалогов",
            ok: "Ок",
            cancel: "Отмена",
            chatCount: "Количество диалогов",
            shortest: " Самый быстрый",
            longest: "Самый долгий",
            average: " В среднем",
            count: "Количество",
            averagePoint: "Средняя оценка",
            pointDist: "Распределение оценок",
            point: "Оценка",
            filters: " Фильтры",
            totalCustomer: " Всего клиентов",
            avResponseTime: "Среднее время первого ответа",
            breakDuration: " Перерыв",
            breakCount: " Количество перерывов ",
            lastLoginPlatform: "Platform",
            active: "Активный",
            passive: "Пассивный",
            userForm: " Форма пользователя ",
            profile: "Профиль",
            name: "Имя",
            number: "Число",
            username: "Имя пользователя",
            updateUserName: "Обновить имя пользователя",
            email: "Эл. адрес",
            password: "Пароль",
            oldPassword: "Старый пароль",
            newPassword: "Новый пароль",
            passwordAtLeast: "Пароль (не менее {num} символов)",
            passwordRepeat: " Пароль снова ",
            changePassword: " Изменить пароль ",
            status: "Статус",
            douYouWishToDeleteUser: " Вы действительно хотите удалить этого пользователя?",
            userDeleted: " Пользователь удален ",
            userSaved: " Пользователь зарегистрирован.",
            oldPasswordError: " Старый пароль неверен.",
            userVolumeUpdated: " Настройки звука обновлены.",
            save: "Сохранить",
            update: "Обновить",
            addNewMenu: " Добавить новое меню ",
            addNewContent: " Добавить новый контент ",
            pleaseTitleEnter: "Пожалуйста, введите заголовок",
            like: "Рейтинг",
            disLike: "Не нравится ",
            users: "Представители",
            allContacts: "Все контакты",
            allUsers: "Все представители",
            allSites: " Все сайты ",
            newUser: "Новый представитель",
            noNewUser: " Представителя пока нет.",
            noNewAdminUser: " Еще нет представителя с правами администратора.",
            noRoleFound: "Должности ещё нет.",
            noBannedWordFound: " Запрещенных слов пока нет.",
            noWelcomeMessageFound: " Приветственного сообщения пока нет.",
            noSubjectFound: " Пока нет тем.",
            noVisitorFound: " Посетителей не найдено.",
            noContactFound: "Нет контакта",
            sendResponse: " Напишите ответ.",
            delete: " Удалить",
            noRePresentativeFound: " Представитель не найден.",
            noLiveSupportFound: " Пока нет записи о живой поддержке.",
            noBannedVisitorFound: "Забаненных посетителей пока нет.",
            removeBanDescription: " Снять запрет ",
            editThisItem: " Обновить эту запись",
            removeThisItem: " Удалить эту запись ",
            role: "Должность",
            newRolePlaceHolder: " Щелкните, чтобы добавить новую должность...",
            autoChatAssignLimit: " Предел автоматического присвоения речи ",
            chatAssignInfo:
                "-1 = Системное значение по умолчанию, 0 = Нет назначения,> 0 = Назначить столько, сколько заданное значение.",
            relatedDepartments: "Связанные отделы",
            subjectInfo: " Если тема не выбрана, будут разрешены все темы..",
            archive: "Архив",
            offlineSupportRequests: " Офлайн-поддержка ",
            offlineModeMessage: " Автономное сообщение ",
            offlineMode: " Автономный режим ",
            first: " Первый ",
            last: "Последний",
            query: " Начать поиск ",
            clean: "Очистить",
            loading: " Загрузка ",
            loadMore: " Загрузи больше",
            noMessage: " Нет сообщений...",
            selectChat: " Выбрать чат",
            noMessageInChat: " В этом чате сообщений не найдено ",
            userInfo: " Информация о пользователе ",
            chatId: " ID чата",
            visitingPage: " Посещение страницы",
            osAndBrowser: " Операционная система и браузер ",
            customerClientVersion: " Клиентская версия",
            visitorFeedback: " Обратная связь с клиентами ",
            nameSurname: " Имя Фамилия ",
            chats: "Чаты",
            bannedVisitors: " Запрещенные посетители ",
            country: " Страна ",
            city: " Город ",
            cityDistrict: " Район ",
            browser: "Браузер",
            os: " Операционные системы ",
            ipAddress: "IP Адрес",
            connectionDate: " Время подключения ",
            transaction: " обработка ",
            banRemoved: " Блокировка снята.",
            bannedWords: " Запрещенные слова ",
            newBannedWord: " Новое запрещённое слово ",
            noBannedWord: "Нет запрещённых слов.",
            bannedWordForm: " Запрещенная форма слова ",
            word: " Слово",
            bannedWordAndWordGroup: " Запрещенное слово / фраза ",
            doYouWishToDeleteBannedWord: " Вы действительно хотите удалить это запрещенное слово?",
            doYouWishToOfflineSupportRequest: " Вы хотите удалить это сообщение?",
            bannedWordSaved: " Запрещенное слово было записано ",
            deletedSuccessfully: " Успешно удалено ",
            deleteErrorMsg: " Не удалось удалить, попробуйте еще раз. ",
            socketError: " Sockete Проблема с подключением. Обновите страницу и попробуйте еще раз. ",
            socketConnecting: " Связь с сервером ",
            offlineModeDescription:
                " Система не работает, клиенты не смогут получить доступ к поддержке в реальном времени.",
            offlineModeSettingsDescription: " Проверьте функцию 'Автономный режим' в меню настроек..",
            offlineModeUser: " В системе должен быть хотя бы один онлайн-представитель.",
            adminCannotConnectSocket: "Администраторы не могут подключиться к soket.",
            liveSupport: " Живая поддержка ",
            siteVisitors: " Посетители сайта ",
            visitors: " Посетители ",
            thoseConnectedToLiveSupport: " Подключено к Live Support ",
            visitorHistory: " История посетителей ",
            privateMessage: " Личное сообщение ",
            addRepresentative: " Добавить представителя ",
            forwardRepresentative: " Обратитесь к представителю ",
            keyboardShortcuts: " Горячие клавиши ",
            chatColorMeanings: "Значение цвета чата",
            connLostCheckInternet: " Ваше соединение потеряно. Убедитесь, что у вас есть подключение к Интернету.",
            wishToEndThisChat: " Вы хотите закончить этот разговор?",
            defaultContents: "ярлык",
            newDefaultContent: " Новый готовый контент ",
            newCTRLContent: "CTRL Добавить содержание ",
            newALTContent: "ALT Добавить содержание ",
            newTABContent: "TAB Добавить содержание ",
            title: " Заголовок ",
            shortcutChar: " Ярлык",
            pickOne: " Выберите один ",
            writeSomething: " Введите символ (a-z | 0-9)",
            letterSequence: "Последовательность букв",
            exampleText: " Пример: фут - > футбол ",
            anyChar: "anyChar",
            shorcutKey: " Быстрая клавиша ",
            content: " Содержание ",
            shortcutName: " Название ярлыка ",
            type: "тип",
            shortcut: "Ярлык",
            deleteContentQuestion: " Вы действительно хотите удалить этот готовый контент?",
            defaultContentDeleted: " Готовый контент удален.",
            defaultContentSaved: " Готовый контент сохранен.",
            defaultContentForm: "Готовая форма содержания",
            contentMoved: " Контент был перемещен.",
            cannotMoveFullParent: "Вы не можете переместить этот элемент",
            yourEmail: " Адрес электронной почты ",
            yourName: "Ваше имя",
            lostPassword: " я забыл мой пароль ",
            login: "Авторизоваться",
            forgotPassword: "Забыл мой пароль",
            multipleSession: "Вы вошли в систему где-то еще.",
            notAuthorizedToDisplayPage: " У вас нет разрешения на просмотр этой страницы!",
            permissions: "Разрешения",
            newPermission: " Новое Разрешение ",
            permissionForm: "Форма разрешения",
            displayTitle: " Отображать заголовок ",
            key: "ключ",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: " Вы действительно хотите удалить это разрешение?",
            permissionDeleted: " Разрешение удалено.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Новая должность",
            selectARole: " Выберите должность ",
            yes: "Да",
            no: "Нет",
            fullAuth: " Полные полномочия ",
            roleDeleted: " Должность удалена.",
            roleSaved: " Должность сохранена.",
            roleForm: " Должностная форма ",
            roles: "Должности",
            settings: " Настройки ",
            selectTopic: " Выбор темы ",
            autoCallTransfer: " Автоматический перевод вызова ",
            customerTyping: " Типы пользователей ",
            typing: "печатание",
            agentTyping: " Представитель пишет ",
            disconnectTime: "Конец разговора (сек)",
            tippyDissconnectTime:
                " Устанавливает количество секунд, по истечении которых стационарный разговор будет отключен. ",
            queueNumberVisibleFeature: " Показать количество посетителей в очереди ",
            privateChatEnabled: " Показать чат между представителями ",
            delayedTalkTime: " Время задержки (сек)",
            employeeAverageChatCount: " Среднее количество разговоров в чате персонала ",
            customerDownTimeWhenRepExit: " Время ожидания клиента при выходе представителя (сек.)",
            autoAssignLimit: "Предел автоматического назначения",
            wasted: "потрачено (сек)",
            settingsSaved: " Настройки сохранены.",
            settingFormWrong: " Введенные вами данные неверны, проверьте и попробуйте еще раз.",
            delayTime: " Время задержки (сек.)",
            sites: " Сайты ",
            newSite: " Новый сайт ",
            noSiteYet: " Сайта пока нет.",
            siteAddress: " Адрес сайта ",
            customerRepLimit: "Лимит представителя клиента",
            siteSaved: " Сайт зарегистрирован.",
            siteSaveError: " Произошла ошибка при создании сайта.",
            subjects: " Темы ",
            newSubject: " Новая тема ",
            noSubject: " Темы пока нет.",
            subject: " Тема ",
            subjectTitle: " Заголовок темы ",
            description: " Описание ",
            infoAboutSubject: " Краткая информация по теме ",
            deleteSubjectQuestion: " Вы действительно хотите удалить эту тему?",
            subjectDeleted: " Тема удалена ",
            subjectSaved: " Тема сохранена.",
            osrFromMessageSaved: " Автономное сообщение записано.",
            welcomeMessages: " Приветственные сообщения ",
            newWelcomeMessages: " Новое приветственное сообщение ",
            noWelcomeMessage: " Еще нет приветственного сообщения.",
            welcomeMessageContent: " Содержание приветственного сообщения ",
            makeChoice: " Сделайте выбор...",
            welcomeMessage: " Приветствие ",
            repLoggedIn: " Представитель вошел в систему ",
            loginMessage: " Сообщение о выходе ",
            message: " Сообщение ",
            deleteWelcomeMessageQuestion: " Вы действительно хотите удалить это приветственное сообщение?",
            welcomeMessageDeleted: " Приветственное сообщение было удалено ",
            welcomeMessageSaved: " Приветственное сообщение записано.",
            welcomeMessageForm: " Форма приветственного сообщения ",
            noRep: " Пока нет представителя.",
            addChat: " Добавить в разговор ",
            forwardChat: "переадресовать чат кому-нибудь",
            ago: "тому назад",
            repName: " Имя представителя ",
            lastOnline: " Последнее подключение / время в сети ",
            lastStatusChange: " Последнее изменение статуса ",
            activeChat: " Активная беседа ",
            userMaxCapacity: " Максимальная емкость чата ",
            noActiveChat: " Нет активного разговора.",
            watch: " СМОТРЕТЬ ",
            join: " ПРИСОЕДИНИТЬСЯ ",
            open: " ОТКРЫТО ДЛЯ ДИАЛОГА ",
            directMessage: " ЛИЧНОЕ СООБЩЕНИЕ ",
            block: " ЗАБЛОКИРОВАТЬ ",
            transactions: " Операции ",
            informations: " Информация ",
            visitStart: " Начало визита ",
            fullName: " Имя и фамилия ",
            waitChatTime: " Время ожидания / время разговора ",
            blockUserConfirm: " Вы действительно хотите заблокировать этого пользователя ?",
            messaging: " Обмен сообщениями ",
            hideChat: " Скрыть диалог",
            block_: " Заблокировать ",
            privateMessage_: " Секретное сообщение ",
            assignRep: " Назначить представителя ",
            joinChat: "Присоединиться к чату",
            forwardRep: " Перенаправить ",
            leaveChat: "Выйти из разговора",
            endChat: " Завершить разговор ",
            translatedTextDescription: "Амазонка перевел это сообщение {from} -> {to}.",
            autoTranslate: "Автоматический перевод",
            translateThisMessage: "Перевести это сообщение",
            autoTranslateDetectedDesc:
                "Язык посетителя: {visitorLanguage}. Нажмите здесь, чтобы активировать автоматический перевод",
            on: "вкл",
            off: "выкл",
            copy: " Копировать ",
            prevChats: " Предыдущие диалоги ",
            noShortCut: " Нет ярлыка ",
            leaveChartConfirm: " Вы уверены, что хотите выйти из разговора?",
            endChatConfirm: " Вы хотите закончить этот разговор?",
            chatBar: " Панель разговора ",
            endConversation: " Завершить разговор ",
            onlyOneRep: " Вы единственный представитель в этом разговоре!",
            chatList: " Список диалогов",
            unreadTitle: " Непрочитанные",
            visitorLeftTitle: " Выход посетителя ",
            activeChatTitle: " Активный диалог",
            autoAssignedTitle: " Назначено автоматически ",
            watchModeTitle: " Режим просмотра",
            lostChat: " Соединение представителя прервано ",
            repLostConn: " Фон диалога становится розовым, если представитель отключен от диалога.",
            chatWidthDelay: "Отложенный чат",
            repChatWidthDelay:
                " Когда в системе нет активного представителя или когда нет посетителей из-за плотности, фон речи становится зеленым. ",
            unreadMsg: " Если есть непрочитанное сообщение, фон будет голубым.",
            visitorLeftChat: " Если посетитель покидает беседу, фон становится темно-серым..",
            activeChatMsg: " Если разговор активен, фон будет зеленым ",
            autoAssignMsg:
                " Если назначено автоматическим назначением и разговор еще не просматривался, фон будет горчичным",
            watchModeMsg: " Фон становится красным, когда чат открыт в режиме просмотра ",
            online: " В сети ",
            beRightBack: "Скоро вернусь",
            away: " Скоро вернусь",
            busy: " Занят",
            offline: " Не в сети ",
            logout: " Выйти",
            forWindows: " Для Windows ",
            forMac: "Для Mac",
            nextChatFromActive: " Переключиться с активного разговора на следующий разговор ",
            previousChatFromActive: " Перейти от активного разговора к предыдущему разговору ",
            hideActiveChat: " Скрыть активную беседу ",
            closeActiveChat: " Остановить активный разговор ",
            firsthiddenChat: " Подключиться к чату самого ожидающего клиента ",
            firstChatWaiting: " Переключиться на ожидающий разговор ",
            previousOpenedChat: " Перейти к первому открытому разговору вне зависимости от порядка ",
            historyDetails: " Подробности истории",
            chat: "Чат",
            chatNotFound: " Чат не найден.",
            visitorInfo: " Информация для посетителей ",
            timeSpent: "Время вышло",
            noActiveVisitors: " Нет активных посетителей ",
            select: " Всплывающее меню ",
            fullname: " ФИО",
            text: " Текст ",
            numeric: "Числовой",
            phone: " Телефон",
            optionsPlaceholder: "Значение параметра",
            selectField: " Щелкните, если хотите добавить раскрывающееся меню ",
            fullnameField: "Нажмите, если хотите добавить поле Полное имя.",
            textField: " Щелкните, если хотите добавить текстовое поле.",
            numericField: " Щелкните, если хотите добавить числовое поле.",
            phoneField: " Нажмите, если хотите добавить поле телефона.",
            departmentField: "Щелкните, если вы хотите добавить поле отдела.",
            emailField: " Нажмите, если хотите добавить домен электронной почты.",
            visible: " Видимый ",
            required: " Обязательство ",
            label: "Описание",
            totalConnected: "Количество диалогов",
            missedChat: " Количество пропущенных диалогов",
            workTime: " Рабочее время ",
            closedChatCount: " Закрытые диалоги",
            activeConvo: "Активные диалоги",
            notAnswered: "Ещё не ответили",
            delayedConvo: " Отложенные диалоги",
            leavingRep: " Выделенный представитель",
            staffRate: " Уровень занятости сотрудников ",
            customLoginAlert: "Ваша форма входа должна содержать хотя бы одно поле.",
            atLeastOneLanguage: " Должно быть хотя бы одно языковое описание.",
            requiredField: " Это поле обязательно к заполнению.",
            notRequiredField: " Это поле не обязательно.",
            visibleField: "Это поле видно.",
            notVisibleField: "Это поле не отображается.",
            connectServer: " Вы подключены к серверу ",
            disconnectServer: " Ваше соединение с сервером было потеряно ",
            liveChatOff: " Живая поддержка отключена ",
            visitorScreen: " Отображение посетителей ",
            showHint: " Показать подсказку ",
            dontShowHint: " Показать подсказку",
            liveChatOn: " Онлайн-поддержка открыта ",
            nightModeOff: " Ночной режим выключен ",
            nightModeOn: " Ночной режим включен ",
            edit: " Редактировать ",
            deleteField: " Удалить ",
            arrow_upward: " Переместить вверх ",
            arrow_downward: " Переместить вниз ",
            doubleClickEdit: " Дважды щелкните или нажмите «Редактировать», чтобы отредактировать.",
            newCatalogCategory: "Новая категория каталога",
            childCreate: " Нажмите, чтобы создать дополнительный контент ",
            updateCatalogCategoryFrom: "Форма обновления категории каталога",
            newCatalogCategoryFrom: "Форма новой категории каталога",
            catalogMenu: " Меню ",
            catalogContent: " Содержание ",
            catalogCategoryName: " Название категории каталога ",
            newCatalogContentFrom: "Форма содержания нового каталога",
            catalogContentName: " Название содержимого каталога ",
            catalogCategorySaved: " Категория каталога сохранена ",
            catalogCategoryDeleted: " Категория каталога удалена.",
            catalogCategoryRate: " Оценка содержания ",
            catalogContentFeature: "Каталог Особенности",
            vtipyAudioLevel: " Используется для отключения или включения звуков уведомлений.",
            vtipyOrganizationName: " Вы можете изменить название организации и обновить его.",
            vtipyBrandVisibility: " Supsis - это настройка отображения тега в пузыре чата.",
            vtipyBrandVisibilityForced: "Только пользователи ProPlan могут изменять!!",
            vtipyClientDefault: " Здесь вы можете изменить язык страницы представителя.",
            vtipyCustomerClientDefault: " Здесь вы можете изменить язык страницы клиента (чата).",
            vtipyVisitorPreferredLang: "Клиент может выбрать разговорный язык на странице (Чат).",
            vtipyCustomerClientLanguageDetect: " Вы можете автоматически определять язык страницы клиента (чат).",
            vtipySelectTopic: "Происходят автоматические назначения существующим представителям в выбранном отделе.",
            vtipyAutoCallTransfer: " Автоматически назначает ожидающие вызовы доступным операторам.",
            vtipyCustomerTyping: " Позволяет вам видеть, что написал клиент на экране чата на экране чата агента.",
            vtipyAgentTyping: " Показывает статус записи представителя в пузыре клиента.",
            vtipyQueueNumberVisibleFeature:
                " Когда представители заняты, это показывает клиентам, которые хотят подключиться, в каком порядке они находятся.",
            vtipyPrivateChatEnabled: " Показывает панель разговора между агентами.",
            vtipyDelayedTalkTime: ' Ярлык "Отложенная речь ", если в это время к разговору не подключены агенты.',
            vtipyOfflineMode: " Позволяет перевести систему в автономный режим.",
            vtipyAutoAssignLimit: " Определяет, сколько клиентов (чатов) будет автоматически назначено представителю..",
            vtipyCustomerDownTimeWhenRepExit: " Время ожидания клиента (сек.)",
            tippyDisconnectTime: " Время закрытия чата после отключения клиента (сек.).",
            changeSettings: " Изменить глобальную настройку ",
            totalBg: "ОБЩЕЕ",
            activeBg: "АКТИВНЫЙ",
            watchBg: "ОТСЛЕЖИВАНИЕ",
            waitingBg: "ОЖИДАЮЩИЙ",
            lateBg: " ЗАДЕРЖКИ",
            freeBg: "праздный",
            maxCapacityBg: "МАКС МОЩНОСТЬ",
            addNewSettings: " Добавить новую глобальную настройку",
            darkMode: "Ночной режим",
            clientDefault: "Язык панели по умолчанию",
            customerClientDefault: "Язык по умолчанию для клиентской части",
            customerClientLanguageDetect: "Автоматическое определение языка клиентской части",
            visitorPreferredLang: "Позвольте клиенту выбрать разговорный язык",
            preferredThemeColor: " Настройка темы разговорного экрана ",
            detail: "Рассмотрение",
            supportUs: "Свяжитесь с нами (Живая поддержка)",
            langSetting: "Настройка языка",
            changeLang: "изменение языка",
            fontSizeSetting: "Настройка увеличения экрана",
            changeLangDesc: "Устанавливает язык приложения на {code}.",
            trLang: "Турецкий",
            enLang: "Английский",
            fieldRequired: "{field} Поле, обязательное для заполнения.",
            selectALanguage: "Выберите язык",
            selectATheme: "Выберите тему",
            responseForm: "Форма ответа",
            clientRequestInfo: "Информация о запросе клиента ",
            createdDate: "Дата создания",
            descMessage: "Сообщение",
            new: "Новое",
            selectAllPermission: "Выбрать все",
            catalogCategories: "Каталог",
            copiedClipboard: "Скопировано в буфер обмена",
        },
        adminUser: {
            newAdminUserForm: " Форма регистрации нового администратора ",
            updateAdminUserForm: " Форма обновления пользователя-администратора ",
            adminUsers: " Пользователи с правами администратора ",
            newAdminUser: " Новый пользователь-администратор ",
            noAdminUser: " Еще нет пользователя с правами администратора.",
            adminUserName: " Имя пользователя администратора ",
        },
        report: {
            detailReport: " Детальный отчет ",
            dailyReports: " Ежедневный отчет ",
            pointBasedReports: " Отчеты на основе оценок ",
            personDateBasedPointReport: " Отчет об оценке по количеству людей и дней ",
            personDateBasedReport: " Персональный и дневной отчет ",
            personBasedReport: " Персональные отчеты ",
            personAndDateBasedGraph: " График  людей и дней ",
            noReport: " Нет отчета ",
            reports: " Отчеты ",
            totalBar: " Общее ",
        },
        stats: {
            total: " Количество активных разговоров в системе.",
            active: " Количество принадлежащих вам активных разговоров.",
            waiting: " Количество новых активных разговоров, ожидающих делегирования.",
            late: " Количество новых разговоров, прошедших определенный период времени и ожидающих делегирования.",
            free: " Количество разговоров, ожидающих назначения нового представителя после выхода представителя из системы..",
            pco: "[Personel Çalışma Oranı] : Это коэффициент занятости от общего количества звонков, которые могут получить онлайн-представители в системе. ",
            maxCapacity:
                " Это максимальное количество чатов, которое система может назначить представителям без ожидания. ",
            chatbot: ` Количество активных разговоров чат-бота `,
        },
        time: {
            today: " Сегодня ",
            yesterday: "Вчера",
            lastWeek: " Прошлая неделя ",
            currentWeek: " Эта неделя ",
            currentMonth: " Этот месяц ",
            lastMonth: " Прошлый месяц ",
            last30Day: " Последние 30 дней ",
            allTime: " Все время ",
            custom: " Другое время ",
        },
        fastWizard: {
            tellUsMore: "Расскажите нам больше, чтобы мы могли персонализировать ваш опыт",
            moreInfo: "Больше информации",
            display: "Отображать",
            availability: "Доступность",
            preview: "Предварительный просмотр",
            installCode: "Установить код",
            previous: "Предыдущий",
            setupSupsisLiveChat: "Настроить чат SUPSIS LIVE",
            continue: "Следующий шаг",
            completeInitialize: "Завершить инициализацию",
            completedMessage: "Настройка чата SUPSIS LIVE успешно завершена.",

            websiteIntegration: "Адрес вашего веб-сайта для интеграции онлайн-чата supsis",

            customizeLiveChat: "Настройте свой онлайн-чат",
            createBrandedExperience: "Создайте фирменный чат для ваших посетителей.",
            chatColor: "Цвет чата",
            chatBubble: "Пузырь чата",
            selectBubble: "Выберите всплывающее окно чата",
            chatBubbleColor: "Цвет пузыря чата",
            selectChatBubbleColor: "Выберите цвет пузыря чата",
            customSelection: "Пользовательский выбор:",

            chatAvailability: "Доступность чата",
            onlineSupportVisitorTime: "Когда вы в сети, чтобы поддержать посетителей?",
            channelAvailability: "Доступность канала",
            availability724: "Чат доступен 7/24",
            basedOnTeam: "На основе статуса члена команды",
            basedOnTeamExplanation: "Чат появится в сети, если хотя бы 1 участник станет доступным.",
            customHours: "Индивидуальные часы работы",
            customHoursExplanation: "Настройте свое рабочее время",
            customHoursTimezone: "Часовой пояс:",
            customHoursFrom: "Из:",
            customHoursTo: "К:",
            customHoursAddHours: "+Добавить часы",

            previewDesktop: "Рабочий стол",
            previewIpad: "IPad",

            installationAndInstructions: "Инструкция & установке",
            installationTrackingCode: "Установите код отслеживания на свой сайт",
            installationTrackingCodePlease:
                "Вставьте код в соответствии с приведенными ниже инструкциями непосредственно перед концом тега {bodyTag} на любую страницу, на которой вы хотите включить чат SUPSIS Live.",
            installationInstructionsJavascript:
                " Вставьте приведенный выше код интеграции в тег {bodyTag} непосредственно перед закрывающим",
            installationInstructionsShopify1: "1. Войдите в свою панель Shopify",
            installationInstructionsCopy: "Копировать",
            installationInstructionsCoppyMessage: "Скрипт интеграции скопирован в буфер обмена",
            installationInstructionsShopify2:
                "2. Перейдите в Интернет-магазин> Темы> раскрывающееся меню Действия в разделе Текущая тема> Изменить код> тема.жидкость.",
            installationInstructionsShopify3:
                "3. Вставьте приведенный выше код интеграции непосредственно перед тегом {bodyTag} в конце скрипта theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Войдите в свою дилерскую панель.",
            installationInstructionsIdeaSoft2: "2. Зайдите в Настройки -> SEO -> Службы поисковых систем.",
            installationInstructionsIdeaSoft3:
                "3. Выберите «Проверка сайта с помощью метатега» в разделе «Код отслеживания».",
            installationInstructionsIdeaSoft4:
                "4. Скопируйте и вставьте приведенный выше код интеграции в открывшееся поле и сохраните.",
            installationInstructionsIdeaSoft5:
                "5. Внутри настроек -> Оптимизация нажмите кнопку «Очистить кеш». На этом интеграция завершена.",
            installationInstructionsWordPress1: "1. Войдите в свою админ панель WordPress.",
            installationInstructionsWordPress2: "2. Перейдите в Внешний вид> Редактор тем.",
            installationInstructionsWordPress3:
                "3. В разделе «Файлы темы» (крайний справа) найдите нижний колонтитул темы (footer.php) и выберите его.",
            installationInstructionsWordPress4:
                "4. Вставьте приведенный выше код интеграции перед тегом {bodyTag} внизу.",
            installationInstructionsWordPress5: "5. Нажмите «Обновить файл», чтобы сохранить изменения.",
            installationInstructionsOpenCart1: "1. Войдите в свою админ панель Opencart.",
            installationInstructionsOpenCart2: "2. Перейдите в Внешний Дизайн > Редактор тем.",
            installationInstructionsOpenCart3: "3. Выберите «общую» папку и откройте файл 'header.twig'.",
            installationInstructionsOpenCart4:
                "4. Вставьте приведенный выше код интеграции перед тегом {headTag} внизу.",
            installationInstructionsOpenCart5: "5. Нажмите кнопку сохранения.",
            installationInstructionsTicimax1: "1. Войдите в свою административную панель Ticimax.",
            installationInstructionsTicimax2:
                "2. Откройте «Дизайн» > «Настройки дизайна» > «Дизайн нижнего колонтитула верхнего колонтитула».",
            installationInstructionsTicimax3: "3. Нажмите кнопку «Источник» в разделе дизайна логотипа.",
            installationInstructionsTicimax4: "4. Вставьте код интеграции выше под HTML-кодом.",
            installationInstructions: "инструкции",
            installationVerify: "Убедитесь, что на вашем сайте установлен SUPSIS",
            installationVerifyChecking: "Проверка",
            installationVerifyCheck: "Проверять",
            installationVerifyCheckingStatus: "Проверка статуса интеграции SUPSIS на {website} сайт",
            installationCheckingStatusMessageYes: "Отлично, SUPSIS интегрирован в {website} сайт !!",
            installationCheckingStatusMessageNo: "SUPSIS не интегрирован на {website} сайт!",

            vtippyPreferredLanguage: "предпочтительный язык",
        },
    },
};

export const langResources = messages;
// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "tr",
    messages, // set locale messages
});
